import React, { useState, useCallback, useEffect } from 'react';
// eslint-disable-next-line no-unused-vars
import { FaTrash, FaPlus, FaCheck, FaTimes, FaSpinner, FaFileDownload, FaEye, FaChevronDown } from 'react-icons/fa';
import axios from 'axios';
import '../css/AdminOnboardingInitiate.css';
import {
    stlDigitalCompanyCodeList,
    stlDigitalPurchasingOrgList,
    stlDigitalPaymentTermsList,
    stlDigitalCurrencyList,
    stlDigitalIncoTermsList,
    stlDigitalPaymentMethodList
} from '../../../utils/stldigitalOnboardingData';

// --- API setup ---
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
if (!API_BASE_URL) throw new Error('API base URL not set. Please set REACT_APP_API_BASE_URL in .env');
const api = axios.create({ baseURL: 'https://django-backend-115705416374.asia-south1.run.app' });
// const api = axios.create({ baseURL: 'http://localhost:8000' });
api.interceptors.request.use(config => {
    const token = localStorage.getItem('access');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// --- Required keys ---
const REQUIRED_KEYS = ['vendor_name', 'vendor_email', 'company'];

// --- Helper to generate initial data ---
const getInitialFormData = (fields) => {
    const obj = fields.reduce((acc, field) => {
        acc[field.key] = '';
        return acc;
    }, {});
    REQUIRED_KEYS.forEach(k => {
        if (!(k in obj)) obj[k] = '';
    });
    return obj;
};

// --- Default fields shown on first load ---
const initialFields = [
    { id: 1, key: 'vendor_name', label: 'Vendor Full Name', required: true, type: 'text', removable: false },
    { id: 2, key: 'vendor_email', label: 'Vendor Email ID', required: true, type: 'email', removable: false },
    { id: 3, key: 'company', label: 'Company Name', required: true, type: 'text', removable: false },
    { id: 4, key: 'gst_number', label: 'GST Number (Optional)', required: false, type: 'text', removable: true },
];

let nextId = initialFields.length + 1;

// --- SVG icons ---
const SettingsIcon = ({ size = 18, className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
        viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className={className}>
        <circle cx="12" cy="12" r="3"></circle>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06
        a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06
        a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21
        a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09
        A1.65 1.65 0 0 0 9 19.4
        a1.65 1.65 0 0 0-1.82.33l-.06.06
        a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06
        a1.65 1.65 0 0 0 .33-1.82
        1.65 1.65 0 0 0-1.51-1H3
        a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09
        A1.65 1.65 0 0 0 4.6 9
        a1.65 1.65 0 0 0-.33-1.82l-.06-.06
        a2 2 0 0 1 0-2.83
        2 2 0 0 1 2.83 0l.06.06
        a1.65 1.65 0 0 0 1.82.33H9
        a1.65 1.65 0 0 0 1 1.51V3
        a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09
        a1.65 1.65 0 0 0 1 1.51
        1.65 1.65 0 0 0 1.82-.33l.06-.06
        a2 2 0 0 1 2.83 0
        2 2 0 0 1 0 2.83l-.06.06
        a1.65 1.65 0 0 0-.33 1.82V9
        a1.65 1.65 0 0 0 1.51 1H21
        a2 2 0 0 1 2 2
        2 2 0 0 1-2 2h-.09
        a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
);

const PlusIcon = ({ size = 20, className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
        viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
        className={className}>
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <line x1="5" y1="12" x2="19" y2="12"></line>
    </svg>
);

const TrashIcon = ({ size = 20, className = "", onClick }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}
        viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className={className} onClick={onClick}>
        <polyline points="3 6 5 6 21 6"></polyline>
        <path d="M19 6v14a2 2 0 0 1-2 2H7
        a2 2 0 0 1-2-2V6m3 0V4
        a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
);



const paymentTermsList = [
    { code: '1000', desc: 'Payable immediately Due net' },
    { code: '1001', desc: 'Payment terms as per text.' },
    { code: '1002', desc: '100% advance against ABG' },
    { code: '1003', desc: '100% transferable LC,270days from date of delivery' },
    { code: '1004', desc: '365 days credit period & 100% LC payment' },
    { code: '1005', desc: 'Payable within 10 Days due net' },
    { code: '1006', desc: 'MT Work-100% Payt As Per MS (WC-70%/H-20 %/R-10%)' },
    { code: '1007', desc: 'Row Work - 100% As Per MS (DN-0%,Per R 70%,WC 30%)' },
    { code: '1008', desc: 'Row Work - 100% As Per MS (DN-70%,PerR-20%,WC-10%)' },
    { code: '1009', desc: 'Row Work - 100% As Per MS (DN-50%,PerR-30%,WC-20%)' },
    { code: '1010', desc: 'Within 30 days Due net' },
    { code: '1011', desc: 'OT Work - 100% As Per MS (WC-70%/H-20 %/R-10%)' },
    { code: '1012', desc: 'IBD Work -  Work Comp with HOTO - 90% &  Ret 10%' },
    { code: '1013', desc: 'SUE Work - 100% Payment' },
    { code: '1014', desc: 'RI Work  - 100% As Per MS (WC-50%/NOCR-40%/R-10%)' },
    { code: '1015', desc: 'Within 15 days Due net' },
    { code: '1016', desc: 'Node Delivery50%,HOTO30%,NOC10%,Rtn(>12mnth)10%' },
    { code: '1017', desc: 'Route Completion 80%, BG Recovery 20%' },
    { code: '1018', desc: 'HDD Work - 100% As Per MS (DN-70%/PR-20%/WC-10%)' },
    { code: '1019', desc: 'with in 20 days due net' },
    { code: '1020', desc: 'Within 60 days Due net' },
    { code: '1021', desc: '60 Days Credit from the date of GRN(Vendor Finance' },
    { code: '1022', desc: '120 Days Credit from the date of GRN(Vendor Financ' },
    { code: '1023', desc: '180 Days Credit from the date of GRN(Vendor Financ' },
    { code: '1024', desc: 'payment for 180 days for vendor discount' },
    { code: '1025', desc: 'Within 75 days Due net' },
    { code: '1026', desc: '100% transferable LC,180days from date of delivery' },
    { code: '1027', desc: '100% transferable LC,210days from date of delivery' },
    { code: '1028', desc: '100% transferable LC,240days from date of delivery' },
    { code: '1029', desc: '25% Advance,75% after 60 Days' },
    { code: '1030', desc: 'Within 90 days Due net' },
    { code: '1031', desc: 'LC 180 days -90 % and 10 % ABG after 365 days' },
    { code: '1032', desc: '60 Days From BL After Material Delivery' },
    { code: '1033', desc: 'Within 165 days Due net' },
    { code: '1035', desc: '180d from CCI (certificate of capital importation)' },
    { code: '1036', desc: '90d from CCI (certificate of capital importation)' },
    { code: '1037', desc: 'As Per LoA' },
    { code: '1038', desc: '30 Days Credit from the date of GRN-Vendor Finance' },
    { code: '1039', desc: '45 Days Credit from the date of GRN-Vendor Finance' },
    { code: '1040', desc: 'Within 7 days Due net' },
    { code: '1045', desc: 'within 45 days Due net' },
    { code: '1050', desc: 'within 180 days Due net' },
    { code: '1054', desc: '50% Advance + 50% PDC 45 Days' },
    { code: '1055', desc: '50% Advance payment + 50% LC - 60 days' },
    { code: '1058', desc: '40% within 30 Days' },
    { code: '1060', desc: 'Payable immediately 1 % cash discount' },
    { code: '1070', desc: 'Payable immediately 2 % cash discount' },
    { code: '1080', desc: 'Payable immediately 3 % cash discount' },
    { code: '1090', desc: 'within 7 days 1 % cash discount' },
    { code: '1100', desc: 'within 15 days 1 % cash discount' },
    { code: '1101', desc: '30 days from date of Delivery against BG' },
    { code: '1102', desc: '20%PO,30%beforedispatch&50%after15daysfromDelvry' },
    { code: '1104', desc: '95% on supply, Balance 5% afer 6 months of supply' },
    { code: '1105', desc: '5% Adv. against ABG balance 95% against LC 30 days' },
    { code: '1106', desc: '5% Adv. against ABG balance 95% against LC 90 days' },
    { code: '1107', desc: '14%Adv with PO,68% 180 days BG & 19%Adv befor disp' },
    { code: '1108', desc: '30% Advance & 70% 30 days PDC cheque' },
    { code: '1109', desc: '30% Adv. before prodn. & Bal.70% BG 60days from BL' },
    { code: '1110', desc: 'within 30 days 1 % cash discount' },
    { code: '1111', desc: '100% by Irrevocable LC-89 Days' },
    { code: '1112', desc: '105 days credit period' },
    { code: '1113', desc: 'Bank Transfer 90 From date of Bill of Lading' },
    { code: '1114', desc: '20% against PI & 80% 60 days from presenting BOL' },
    { code: '1115', desc: '​20% advance 50% blowing 30% HOTO - 5% againstSBLC' },
    { code: '1116', desc: '70%supply20%ETC5%PA5%BGsubmisionequalamt' },
    { code: '1117', desc: '10% adv+ 90% lc with 360 days' },
    { code: '1118', desc: '10% adv+10 % against I call + 80 % before dispatch' },
    { code: '1119', desc: '21 days open credit' },
    { code: '1120', desc: 'within 120 days Due net' },
    { code: '1121', desc: '100% by Irrevocable LC-150 Days' },
    { code: '1122', desc: '60% payment from date of delivery -after180 days.' },
    { code: '1123', desc: '60% 180 days 40% 360 days from date of delivery' },
    { code: '1124', desc: '90% payment after 100 days of implementation.' },
    { code: '1125', desc: '330 days open credit' },
    { code: '1126', desc: 'Irrevocable LC-70 Days from the date of Shipment' },
    { code: '1127', desc: 'Supply - 5%advance, Progressive - 85%, Final - 10%' },
    { code: '1128', desc: 'within 60 days Due net' },
    { code: '1129', desc: '20% Advance, 80% within 30 days after dispatch' },
    { code: '1130', desc: 'within 150 days Due net' },
    { code: '1131', desc: '75%Adv&25% at time of Delivery' },
    { code: '1132', desc: '80%adv 60days LC,20%100days LC' },
    { code: '1133', desc: '65%Supply,20%Erction,15%HndOvr' },
    { code: '1135', desc: 'within 270 days Due net' },
    { code: '1136', desc: '80 days from date of BL' },
    { code: '1137', desc: '30 days from Invoice date with 3% Cash discount' },
    { code: '1140', desc: 'within 360 days Due net' },
    { code: '1141', desc: '7% Advance' },
    { code: '1142', desc: '10%adv90%60day ff aft disp.doc' },
    { code: '1144', desc: '20% Before Dispatch' },
    { code: '1145', desc: '80% 60Days from Invoice date' },
    { code: '1146', desc: '10%Adv, 10%Before.Disp, 80% 60D from Invoice date' },
    { code: '1147', desc: '25% advance and 75% against BG before dispatch' },
    { code: '1148', desc: 'within 15 days Due net' },
    { code: '1150', desc: '10% Advance' },
    { code: '1156', desc: '25% Advance,75% Before Disaptch' },
    { code: '1157', desc: '90% payment after 60 days delivery &10% PBG' },
    { code: '1160', desc: '15% Advance' },
    { code: '1170', desc: '20% Advance' },
    { code: '1175', desc: '25% Advance' },
    { code: '1176', desc: '28% Advance' },
    { code: '1180', desc: '30% Adv & Bal. 70% 60 days from Invoice date' },
    { code: '1181', desc: '30% Advance , 70% 45 days from the date of invoice' },
    { code: '1182', desc: '30%Advance' },
    { code: '1183', desc: '70% 45D from Date of Invoice' },
    { code: '1185', desc: '40% Advance' },
    { code: '1190', desc: '50% Advance' },
    { code: '1191', desc: '20%advTT' },
    { code: '1192', desc: '93% LC 60 days' },
    { code: '1193', desc: '80%D/A 60days B/L dt' },
    { code: '1195', desc: '60% Advance' },
    { code: '1196', desc: '65% Advance' },
    { code: '1197', desc: '90%Payment by LC/120days & 10%Payment by LC/180day' },
    { code: '1198', desc: '95%Payment by LC/120days & 5%Payment by LC/180day' },
    { code: '1199', desc: '330 days Credit period LC payment' },
    { code: '1200', desc: '5% Advance' },
    { code: '1205', desc: '30 Days ARO' },
    { code: '1210', desc: '100 % Advance with PO' },
    { code: '1215', desc: '100 % CAD basis' },
    { code: '1216', desc: '75 % CAD basis' },
    { code: '1217', desc: '80 % CAD basis' },
    { code: '1218', desc: '10% Adv & 90% CAD' },
    { code: '1219', desc: '100 % CAD 90 Days' },
    { code: '1220', desc: '100 % COD basis' },
    { code: '1221', desc: '100 % CAD 30 Days' },
    { code: '1222', desc: '100 % CAD 45 Days' },
    { code: '1223', desc: '100% CAD 60 Days Credit' },
    { code: '1225', desc: '100 % Advance By TT' },
    { code: '1230', desc: '90 % Advance' },
    { code: '1235', desc: '95 % Advance' },
    { code: '1240', desc: '25 % Advance 75% in 30 days' },
    { code: '1300', desc: 'within 70 days Due net' },
    { code: '1302', desc: 'Payment Term 300 Days' },
    { code: '1500', desc: 'Payable immediately Due net' },
    { code: '1515', desc: '5​% Adv and 95% on 60th day of of mat. receipt' },
    { code: '1590', desc: 'Payable in 5 partial amounts\n\t1. installment: 9.818 % with payment term 1591\n\t2. installment: 78.543 % with payment term 1592\n\t3. installment: 0.839 % with payment term 1593\n\t4. installment: 9.818 % with payment term 1594\n\t5. installment: 0.982 % with payment term 1595' },
    { code: '1591', desc: '10% Advance' },
    { code: '1592', desc: '80% in 30 days' },
    { code: '1593', desc: 'F&I' },
    { code: '1594', desc: '10% in 60 Days' },
    { code: '1597', desc: '10% in 90 Days' },
    { code: '1598', desc: '10.3% ED in 30 days\n\t10.3% ED in 30 days' },
    { code: '1599', desc: 'Payable immediately Due net' },
    { code: '1600', desc: '90%by Irrevocable LC -30 Days Usance' },
    { code: '1601', desc: '90% against LC 90 days & 10% against PBG' },
    { code: '1602', desc: 'Payment in 3 Installments\n\tInstallment 1. : 50 % with 29 days due net\n\tInstallment 2. : 45% with 30 days due net\n\tInstallment 3. : 5% Retention after 360 days' },
    { code: '1920', desc: '95% within 45 days against LC' },
    { code: '1921', desc: '5% within 365 days against' },
    { code: '1922', desc: '95 % Within 45 Days Due' },
    { code: '1923', desc: '5% Retention in 365 Days Due' },
    { code: '1930', desc: 'Amount 95% in 45D Due & 5% retention 12 months Due' },
    { code: '1931', desc: 'Amount 95% in 60D Due & 5%retention 18months Due' },
    { code: '1932', desc: 'Amount 95% in 60D due net' },
    { code: '1933', desc: '5%retention 18months Due' },
    { code: '1934', desc: '90% in 30days & 10% Ret- after 1.5 Ys after (HOTO)' },
    { code: '1935', desc: '90% in 45days & 10% Ret- after 1.5 Ys after (HOTO)' },
    { code: '1936', desc: '90% in 60days & 10% Ret- after 1.5 Ys after (HOTO)' },
    { code: '1937', desc: '95% in 30days & 5% Ret- after 1Year after (HOTO)' },
    { code: '1938', desc: '95% in 45days & 5% Ret- after 1Year after (HOTO)' },
    { code: '1939', desc: '95% in 60days & 5% Ret- after 1Year after (HOTO)' },
    { code: '1940', desc: '95% in 75days & 5% Ret- after 1Year after (HOTO)' },
    { code: '1941', desc: '95% in 30days & 5% Ret-after 1.5 Year after (HOTO)' },
    { code: '1942', desc: '10% adv agt ABG 80% Us L/C 150 10% bal.agnt PBG' },
    { code: '1943', desc: '95% in 30 days & 5% in 90 days after HOTO' },
    { code: '1944', desc: '95% within 30days' },
    { code: '1945', desc: '5% within 90 days' },
    { code: '2310', desc: '10 % advance' },
    { code: '2320', desc: '90% within 30 days against LC' },
    { code: '2330', desc: '91.379% in 30Days & 8.621% retention after 360Days' },
    { code: '2340', desc: '10 % retention shall be released after 360 days' },
    { code: '2605', desc: 'Payable in 5 partial amounts\n\t1. installment: 9.678 % with payment term 260A\n\t2. installment: 77.424 % with payment term 260B\n\t3. installment: 2.252 % with payment term 260C\n\t4. installment: 9.678 % with payment term 260D\n\t5. installment: 0.968 % with payment term 260E' },
    { code: '2656', desc: '70% on Material Delivery in 30days of Invoice' },
    { code: '2657', desc: '30% Material Value on GP Commissioning in 180Days' },
    { code: '2658', desc: '70% on MatDelv in 30D & 30% on GP Comm in 180D' },
    { code: '2659', desc: '100% on GP Commissioning in 30D from invoice date' },
    { code: '2730', desc: 'Payable in 1 partial amount\n\t1. installment: 10.000 % with payment term 2710' },
    { code: '279A', desc: 'C-47304-L075-3/LOA/2799 10-80-10%' },
    { code: '279B', desc: 'C-47304-L075-3/LOA/2799 10-80-10%' },
    { code: '279C', desc: 'C-47304-L075-3/LOA/2799 10-80-10%' },
    { code: '279D', desc: 'C-47304-L075-3/LOA/2799 10-80-10%' },
    { code: '279E', desc: 'C-47304-L075-3/LOA/2799 10-80-10%' },
    { code: '286B', desc: 'C-34203-LO75-3-NOA-2868-10-80-10%' },
    { code: '3115', desc: '10% agi PBG & 90% agi FAT/Insp Report bef dispatch' },
    { code: '4000', desc: '90 Days From Deliery Date (Exp-America)' },
    { code: '4100', desc: '45 Days From Delivery Date (Exp-Europe)' },
    { code: '4101', desc: '60 Days From Delivery Date (Exp-Europe)' },
    { code: '4102', desc: '30 Days From Delivery Date (Exp-Europe)' },
    { code: '4200', desc: '30 Days From Delivery Date (Domestic)' },
    { code: '4201', desc: '180 Days From Delivery Date (Domestic)' },
    { code: '4202', desc: '60 Days From Delivery Date (Domestic)' },
    { code: '4203', desc: '120 Days From Delivery Date (Domestic)' },
    { code: '4300', desc: '45 Days From Delivery Date (Exp-MEA)' },
    { code: '5001', desc: '43% adv T/T receipt of SH doc & 57 % by LC 30 days' },
    { code: '5003', desc: '100 days after BL 60 days BL with 2% cash discunt' },
    { code: '5040', desc: 'within 40 days Due net' },
    { code: '5091', desc: 'LC -150 days usance' },
    { code: '5180', desc: '100% by Irrevocable LC at Sight' },
    { code: '5181', desc: '90% by  LC at Sight' },
    { code: '5182', desc: '10%  LC on PAT' },
    { code: '5183', desc: '20% by Irrevocable LC at Sight' },
    { code: '5184', desc: '25% by Irrevocable LC at Sight' },
    { code: '5185', desc: '95% by Irrevocable LC at Sight' },
    { code: '5186', desc: '100% by Irrevocable LC-15Days' },
    { code: '5187', desc: '15% adv SBLC 85% LC Sight' },
    { code: '5190', desc: '100% by Irrevocable LC-30 Days' },
    { code: '5195', desc: '100% by Irrevocable LC-45 Days' },
    { code: '5200', desc: '100% by Irrevocable LC-60 Days' },
    { code: '5201', desc: '100% by Irrevocable LC-75 Days' },
    { code: '5205', desc: '100% by Irrevocable LC-80 Days' },
    { code: '5210', desc: '100% by Irrevocable LC-90 Days' },
    { code: '5215', desc: '100% by Irrevocable LC100 Days' },
    { code: '5216', desc: '100% by Irrevocable LC120 Days' },
    { code: '5217', desc: '100% by Irrevocable LC110 Days' },
    { code: '5220', desc: '100% by Irrevocable LC-180 Days' },
    { code: '5221', desc: '90% LC 120 Days' },
    { code: '5222', desc: '100% by Irrevocable LC-240 Days' },
    { code: '5223', desc: '100% by Irrevocable LC-270 Days' },
    { code: '5224', desc: '100% by Irrevocable LC-210 Days' },
    { code: '5225', desc: '70% by LC-30 Day\'s' },
    { code: '5226', desc: '90%LC 30 Days,10%PBG 12 Months' },
    { code: '5227', desc: '95% by Irrevocable LC-30 Days' },
    { code: '5228', desc: '20% ABG, 70% LC, 10% PAT' },
    { code: '5230', desc: 'Documents Against Acceptance at Sight' },
    { code: '5231', desc: '100% by Irrevocable LC-270 Days from LR date' },
    { code: '5240', desc: 'Documents Against Acceptance - 30 Days' },
    { code: '5245', desc: 'Documents Against Acceptance - 45 Days' },
    { code: '5250', desc: 'Documents Against Acceptance - 60 Days' },
    { code: '5255', desc: 'Documents Against Acceptance - 80 Days' },
    { code: '5260', desc: 'Documents Against Acceptance - 90 Days' },
    { code: '5261', desc: 'Documents Against Acceptance - 100 Days' },
    { code: '5264', desc: 'LC-60 Days,with 30 D int.@ 1%' },
    { code: '5265', desc: 'Documents Against Acceptance - 120 Days' },
    { code: '5270', desc: 'Documents Against Acceptance - 180 Days' },
    { code: '5295', desc: '100% by Irrevocable LC 50 Days' },
    { code: '5302', desc: '70% Through LC at Sight' },
    { code: '5304', desc: '70% through LC at 15 days usance period' },
    { code: '5320', desc: 'Payable in 3 partial amounts\n\t1. installment: 30.000 % with payment term 5321\n\t2. installment: 50.000 % with payment term 5322\n\t3. installment: 20.000 % with payment term 5323' },
    { code: '5321', desc: '30% Adv against SBLC' },
    { code: '5322', desc: '50% LC at Sight' },
    { code: '5323', desc: '20% on Installation' },
    { code: '5324', desc: 'Payable in 3 partial amounts\n\t1. installment: 15.000 % with payment term 1160\n\t2. installment: 70.000 % with payment term 5325\n\t3. installment: 15.000 % with payment term 5326' },
    { code: '5325', desc: '70% Against LC' },
    { code: '5326', desc: '15% Installation/LC' },
    { code: '5327', desc: '20% against ABG, Bal in 15 Days' },
    { code: '5330', desc: 'Payable in 2 partial amounts\n\t1. installment: 90.000 % with payment term 5331\n\t2. installment: 10.000 % with payment term 5332' },
    { code: '5331', desc: '90%at sight' },
    { code: '5332', desc: '10% on Installation' },
    { code: '5335', desc: 'Payable in 2 partial amounts\n\t1. installment: 90.000 % with payment term 5331\n\t2. installment: 10.000 % with payment term 5333' },
    { code: '5336', desc: '76% 1st cycle,, 12% 2nd cycle, 12% 3rd cycle' },
    { code: '5340', desc: 'Payable in 2 partial amounts\n\t1. installment: 15.000 % with payment term 5341\n\t2. installment: 85.000 % with payment term 5342' },
    { code: '5341', desc: '15% Adv SBLC' },
    { code: '5342', desc: '85 % at Sight' },
    { code: '5343', desc: '75% by Irrevocable LC at Sight' },
    { code: '5344', desc: '85% by Irrevocable LC at Sight' },
    { code: '5346', desc: '85% LC at Sight 30 Days' },
    { code: '5347', desc: '5% 30days aft date of delivery' },
    { code: '5351', desc: '80% at sight,' },
    { code: '5352', desc: '20% on Installation' },
    { code: '5353', desc: '10% on Installation within 30 days' },
    { code: '5354', desc: '50% on Installation' },
    { code: '5360', desc: 'Payable in 3 partial amounts\n\t1. installment: 40.000 % with payment term 5361\n\t2. installment: 50.000 % with payment term 5322\n\t3. installment: 10.000 % with payment term 5332' },
    { code: '5361', desc: 'Payable immediately 40 % cash discount' },
    { code: '5362', desc: '30% Advance Against ABG' },
    { code: '5363', desc: '60% against mtrl delivey' },
    { code: '5364', desc: '10% after 100% supply of mtrl' },
    { code: '5365', desc: 'Payable in 3 partial amounts\n\t1. installment: 30.000 % with payment term 5362\n\t2. installment: 60.000 % with payment term 5363\n\t3. installment: 10.000 % with payment term 5364' },
    { code: '5366', desc: '10% Advance Against ABG' },
    { code: '5367', desc: '75 % COD basis' },
    { code: '5368', desc: '5% After Commissioning' },
    { code: '5369', desc: '10% Advance Against PBG' },
    { code: '5370', desc: 'Payable in 4 partial amounts\n\t1. installment: 10.000 % with payment term 5366\n\t2. installment: 75.000 % with payment term 5367\n\t3. installment: 5.000 % with payment term 5368\n\t4. installment: 10.000 % with payment term 5369' },
    { code: '5371', desc: '67% Payment' },
    { code: '5372', desc: '33% Payment' },
    { code: '5373', desc: 'Payable in 2 partial amounts\n\t1. installment: 67.000 % with payment term 5371\n\t2. installment: 33.000 % with payment term 5372' },
    { code: '5374', desc: '50% agst mtrl & 50% completion' },
    { code: '5375', desc: '30% within 7 weeks' },
    { code: '5376', desc: 'Payable in 3 partial amounts\n\t1. installment: 20.000 % with payment term 1170\n\t2. installment: 70.000 % with payment term 1000\n\t3. installment: 10.000 % with payment term 5332' },
    { code: '5377', desc: '80% Against LC at Sight' },
    { code: '5378', desc: 'Payable in 2 partial amounts\n\t1. installment: 10.000 % with payment term 5366\n\t2. installment: 90.000 % with payment term 5230' },
    { code: '5379', desc: 'Payable in 3 partial amounts\n\t1. installment: 10.000 % with payment term 1170\n\t2. installment: 70.000 % with payment term 1000\n\t3. installment: 20.000 % with payment term 5332' },
    { code: '5380', desc: 'Payable in 3 partial amounts\n\t1. installment: 15.000 % with payment term 5506\n\t2. installment: 70.000 % with payment term 5325\n\t3. installment: 15.000 % with payment term 5525' },
    { code: '5381', desc: '90%upon mtrl delivey&acceptance' },
    { code: '5382', desc: 'Payable in 2 partial amounts\n\t1. installment: 40.000 % with payment term 1185\n\t2. installment: 60.000 % with payment term 5523' },
    { code: '5385', desc: '15% Adv BG,75% in 30 days,10% after commissioning' },
    { code: '5386', desc: '20% Advance Against ABG' },
    { code: '5391', desc: '15%adv against CG,75%within 30days,10% against CG' },
    { code: '5400', desc: '50% BG ADV, 20% PI, 20% Mtl Rcpt 10% PBG 180 days' },
    { code: '5410', desc: '100 days after Receipt of Invoice' },
    { code: '5420', desc: 'Net 30 Days, 2% discount if paid in 15 Days' },
    { code: '5421', desc: 'Net 60 Days, 15 days 2% cash discount' },
    { code: '5422', desc: 'Net 60 Days, 15 days 1% cash discount' },
    { code: '5423', desc: 'No Discount, 85 Days from B/L date' },
    { code: '5425', desc: 'Net 60 days after del, 1% disc if paid in 15 days' },
    { code: '5500', desc: 'Documents Against Payment at Sight' },
    { code: '5501', desc: 'Payable in 2 partial amounts\n\t1. installment: 90.000 % with payment term 5381\n\t2. installment: 10.000 % with payment term 5505' },
    { code: '5502', desc: 'Payable in 2 partial amounts\n\t1. installment: 90.000 % with payment term 5181\n\t2. installment: 10.000 % with payment term 5182' },
    { code: '5504', desc: '5% Against PBG' },
    { code: '5505', desc: '10%  Against PBG' },
    { code: '5506', desc: '15% Advance Against BG' },
    { code: '5510', desc: '40%  Against  BG' },
    { code: '5511', desc: '30% ADV & BAL AFTER 30 DAYS RECEIVE MAT CUST SITE' },
    { code: '5512', desc: '100 Days from the Date of Delivery' },
    { code: '5514', desc: '100% Against  BG 120 Days' },
    { code: '5515', desc: 'Net 30 Days from Delivery Date' },
    { code: '5516', desc: 'Net 60 Days from Delivery Date' },
    { code: '5517', desc: 'Net 90 Days from Delivery Date' },
    { code: '5518', desc: '180 Days from the Date of Delivery' },
    { code: '5519', desc: 'Net 45 Days from Delivery Date' },
    { code: '5520', desc: '100% Against  BG 30 Days' },
    { code: '5521', desc: '100% Against  BG 60 Days' },
    { code: '5522', desc: '100% Against  BG 90 Days' },
    { code: '5523', desc: '60%  BG Against PDC' },
    { code: '5524', desc: '100% Against  BG 75 Days' },
    { code: '5525', desc: '15% After Commissioning' },
    { code: '5527', desc: 'Payable in 2 partial amounts\n\t1. installment: 80.000 % with payment term 5528\n\t2. installment: 20.000 % with payment term 5529' },
    { code: '5528', desc: '80%within 45days on receipt of material at sight' },
    { code: '5529', desc: '20% aft  commissioning' },
    { code: '5530', desc: '70%IC QA,25%Validation,5%asPO' },
    { code: '5534', desc: '120 Days from date of Delivery' },
    { code: '5535', desc: 'Payable in 3 partial amounts\n\t1. installment: 20.000 % with payment term 5386\n\t2. installment: 70.000 % with payment term 5325\n\t3. installment: 10.000 % with payment term 5505' },
    { code: '5536', desc: '48 % Advance & 52 %  60 DAYS FROM BL DATE' },
    { code: '5537', desc: '75 Days from the date of Invoice' },
    { code: '5539', desc: '150 Days from date of Bill' },
    { code: '5540', desc: 'Payable in 2 partial amounts\n\t1. installment: 65.000 % with payment term 1196\n\t2. installment: 35.000 % with payment term 5050' },
    { code: '5541', desc: 'Payable in 2 partial amounts\n\t1. installment: 50.000 % with payment term 5354\n\t2. installment: 50.000 % with payment term 5030' },
    { code: '5542', desc: 'Payable in 2 partial amounts\n\t1. installment: 95.000 % with payment term 5227\n\t2. installment: 5.000 % with payment term 5140' },
    { code: '5543', desc: 'Payable in 2 partial amounts\n\t1. installment: 95.000 % with payment term 1235\n\t2. installment: 5.000 % with payment term 5140' },
    { code: '5544', desc: '70% Against mtrl delivey' },
    { code: '5545', desc: '10% After PAT' },
    { code: '5546', desc: 'Payable in 4 partial amounts\n\t1. installment: 10.000 % with payment term 5366\n\t2. installment: 70.000 % with payment term 5544\n\t3. installment: 10.000 % with payment term 5369\n\t4. installment: 10.000 % with payment term 5545' },
    { code: '5547', desc: '75%Mtrl receipt,20%Inst,5%asPO' },
    { code: '5548', desc: 'Payable in 2 partial amounts\n\t1. installment: 90.000 % with payment term 5185\n\t2. installment: 10.000 % with payment term 5182' },
    { code: '5549', desc: 'Payable in 2 partial amounts\n\t1. installment: 15.000 % with payment term 1160\n\t2. installment: 85.000 % with payment term 5344' },
    { code: '5550', desc: 'Payable in 3 partial amounts\n\t1. installment: 20.000 % with payment term 1170\n\t2. installment: 70.000 % with payment term 5325\n\t3. installment: 10.000 % with payment term 5182' },
    { code: '5551', desc: 'Payable in 3 partial amounts\n\t1. installment: 10.000 % with payment term 1150\n\t2. installment: 70.000 % with payment term 5325\n\t3. installment: 20.000 % with payment term 5183' },
    { code: '5552', desc: 'Payable in 2 partial amounts\n\t1. installment: 75.000 % with payment term 5343\n\t2. installment: 25.000 % with payment term 5184' },
    { code: '5553', desc: 'Payable in 2 partial amounts\n\t1. installment: 80.000 % with payment term 5377\n\t2. installment: 20.000 % with payment term 5183' },
    { code: '5554', desc: 'Payable in 3 partial amounts\n\t1. installment: 80.000 % with payment term 5377\n\t2. installment: 10.000 % with payment term 5182\n\t3. installment: 10.000 % with payment term 5182' },
    { code: '5555', desc: '30% TT Advance,70% TT Before Shipment' },
    { code: '5556', desc: 'Net 20 Days from Delivery Date' },
    { code: '5557', desc: '75% With Taxes & Duties & PI' },
    { code: '5558', desc: '15% On Mtrl receipt' },
    { code: '5559', desc: '45 Days Open Credit from B/L date' },
    { code: '5560', desc: '40 Days from the date of Invoice' },
    { code: '5561', desc: '45 Days from the date of Invoice' },
    { code: '5562', desc: 'Net 90 Days from the date of Invoice' },
    { code: '5563', desc: '120 Days from the date of Invoice' },
    { code: '5564', desc: '180 Days from the date of Invoice' },
    { code: '5565', desc: '95%LC agst ship doc 5% LC agst  Comm & BG' },
    { code: '5566', desc: '360 Days from the date of Invoice' },
    { code: '5567', desc: 'Net 30 Days from Date of Invoice' },
    { code: '5568', desc: 'Net 60 Days from Date of Invoice' },
    { code: '5569', desc: '30 DAYS FROM BL DATE' },
    { code: '5570', desc: '60 DAYS FROM BL DATE' },
    { code: '5571', desc: '90 DAYS FROM BL DATE' },
    { code: '5572', desc: '120 DAYS FROM BL DATE' },
    { code: '5573', desc: '180 DAYS FROM BL DATE' },
    { code: '5574', desc: '360 DAYS FROM BL DATE' },
    { code: '5575', desc: '100% on work comp 15 days' },
    { code: '5576', desc: '105 DAYS FROM BL DATE' },
    { code: '5577', desc: '100% Against BG' },
    { code: '5578', desc: '100% LC after 2 weeks on PO&BG\n\t100% LC after 2 weeks on PO&BG' },
    { code: '5579', desc: '70%Delivery,20%Aftter Commission,10%PBG' },
    { code: '5580', desc: '60%Errection,30%Aftter Commission,10%PBG' },
    { code: '5581', desc: '40 DAYS FROM BL DATE' },
    { code: '5582', desc: '100% Against ABG & PBG(10%)' },
    { code: '5583', desc: '90%-60D from RA Bill,10%-after final bill Passing' },
    { code: '5584', desc: '80% On Inv Submission,10%-Erection,10%-Line Comm.' },
    { code: '5585', desc: '90% After Commissioning & 10 % Against PBG' },
    { code: '5586', desc: '50%on mtrl supply,40% on comm.,10% againsts PBG' },
    { code: '5587', desc: '70%on mtrl supply,10%-30%work,10%-100%work,10%-PBG' },
    { code: '5588', desc: '50%-Mat Receipt,10%-Varification,30%-Errec,10%-Com' },
    { code: '5589', desc: '100% against dispatch docs on receipt of material' },
    { code: '5590', desc: '10% ABG, 90% Against 90 Days PDC' },
    { code: '5591', desc: '75 DAYS FROM BL DATE' },
    { code: '5592', desc: '40% after mat. supply at site' },
    { code: '5593', desc: '40% after installation and A/T' },
    { code: '5594', desc: '20% after one year-installtion' },
    { code: '5595', desc: '30% Adv 3Days BL Date,70% After 60 days BL date' },
    { code: '5596', desc: 'LC-90 D from mat recpt, with 60 D int.@ 1%' },
    { code: '5597', desc: '50% on Installation' },
    { code: '5598', desc: 'Payable in 3 partial amounts\n\t1. installment: 40.000 % with payment term 1185\n\t2. installment: 50.000 % with payment term 5597\n\t3. installment: 10.000 % with payment term 1010' },
    { code: '5599', desc: 'Payable in 2 partial amounts\n\t1. installment: 10.000 % with payment term 1150\n\t2. installment: 90.000 % with payment term 1218' },
    { code: '5602', desc: '5% adv agst ABG/PBG,85% mat recpt,10%comm.' },
    { code: '5603', desc: '70% as 30days,15% 1st return,15% 2nd return' },
    { code: '5604', desc: '80% within 15days,10% 2nd cycle, 10% 3rd cycle' },
    { code: '5605', desc: '70% by LC-90 Day\'s' },
    { code: '5606', desc: '70% by LC-60 Day\'s' },
    { code: '5620', desc: '30% Advance agnt.ABG, 70% Through LC' },
    { code: '5622', desc: '90% Immediate 10 % against 12 Month PBG' },
    { code: '5623', desc: '25%-after completion of quarter' },
    { code: '5624', desc: '30 % advance and 70 % COD' },
    { code: '5625', desc: '25% Advance,65% after 15 Days,10% after 90 days' },
    { code: '5626', desc: '25% Advance,75% after 30 days' },
    { code: '5627', desc: '15% Adv agains ABG , 70% against PI,15% Commisning' },
    { code: '5628', desc: '10%adv.10%ABG,80%Agst15lacksPBG,10% After Commis.' },
    { code: '5629', desc: '100% Adv within 10 Days from BL Date' },
    { code: '5630', desc: '25%Ast25%ABG55%matRecpt10%ast10%PBG1yr' },
    { code: '5631', desc: '20%Ast20%ABG60%matRct10%astComm10%PBG1yr' },
    { code: '5632', desc: '30% against proforma inv and 70% against delivery' },
    { code: '5633', desc: '50% immediately after invoice,50%15 days from inv.' },
    { code: '5634', desc: '60% Advance & 40% LC at sight.' },
    { code: '5636', desc: 'Payable immediately Due net' },
    { code: '5637', desc: 'LC 222 Days( Net 180 Days Interest Paid)' },
    { code: '5638', desc: '50 Days from the date of Invoice' }
];

const incotermsList = [
    { code: 'C&F', desc: 'Costs and freight' },
    { code: 'CFR', desc: 'Costs and freight' },
    { code: 'CIF', desc: 'Costs, insurance & freight' },
    { code: 'CIP', desc: 'Carriage and insurance paid to' },
    { code: 'CPT', desc: 'Carriage paid to' },
    { code: 'DAF', desc: 'Delivered at frontier' },
    { code: 'DAP', desc: 'Delivered At Place' },
    { code: 'DAT', desc: 'Delivered At Terminus' },
    { code: 'DDP', desc: 'Delivered Duty Paid' },
    { code: 'DDU', desc: 'Delivered Duty Unpaid' },
    { code: 'DEQ', desc: 'Delivered ex quay (duty paid)' },
    { code: 'DES', desc: 'Delivered ex ship' },
    { code: 'DPU', desc: 'Delivery at place unloaded' },
    { code: 'EDL', desc: 'Electronic Delivery' },
    { code: 'EXW', desc: 'Ex Works' },
    { code: 'FAS', desc: 'Free Alongside Ship' },
    { code: 'FCA', desc: 'Free Carrier' },
    { code: 'FH', desc: 'Free house' },
    { code: 'FOB', desc: 'Free on board' },
    { code: 'FOR', desc: 'FOR DESTINATION' },
    { code: 'FTP', desc: 'FTP Delivery' },
    { code: 'NA', desc: 'Not Applicable' },
    { code: 'UN', desc: 'Not Free' }
];

const currencyList = [
    { code: 'ADP', desc: 'Andoran peseta' },
    { code: 'AED', desc: 'United Arab Emirates Dirham' },
    { code: 'AFA', desc: 'Afghani (Old)' },
    { code: 'AFN', desc: 'Afghani' },
    { code: 'ALL', desc: 'Albanian Lek' },
    { code: 'AMD', desc: 'Armenian Dram' },
    { code: 'ANG', desc: 'West Indian Guilder' },
    { code: 'AOA', desc: 'Angolanische Kwanza' },
    { code: 'AON', desc: 'Angolan New Kwanza (Old)' },
    { code: 'AOR', desc: 'Angolan Kwanza Reajustado (Old)' },
    { code: 'ARS', desc: 'Argentine Peso' },
    { code: 'ATS', desc: 'Austrian Schilling' },
    { code: 'AUD', desc: 'Australian Dollar' },
    { code: 'AWG', desc: 'Aruban Guilder' },
    { code: 'AZM', desc: 'Azerbaijan Manat' },
    { code: 'BAM', desc: 'Bosnia and Herzegovina Convertible Mark' },
    { code: 'BBD', desc: 'Barbados Dollar' },
    { code: 'BDT', desc: 'Bangladesh Taka' },
    { code: 'BEF', desc: 'Belgian Franc' },
    { code: 'BGN', desc: 'Bulgarian Lev' },
    { code: 'BHD', desc: 'Bahrain Dinar' },
    { code: 'BIF', desc: 'Burundi Franc' },
    { code: 'BMD', desc: 'Bermudan Dollar' },
    { code: 'BND', desc: 'Brunei Dollar' },
    { code: 'BOB', desc: 'Boliviano' },
    { code: 'BRL', desc: 'Brazilian Real' },
    { code: 'BSD', desc: 'Bahaman Dollar' },
    { code: 'BTN', desc: 'Bhutan Ngultrum' },
    { code: 'BWP', desc: 'Botswana Pula' },
    { code: 'BYB', desc: 'Belorussian Ruble (Old)' },
    { code: 'BYR', desc: 'Belorussian Ruble' },
    { code: 'BZD', desc: 'Belize Dollar' },
    { code: 'CAD', desc: 'Canadian Dollar' },
    { code: 'CDF', desc: 'Congolese Franc' },
    { code: 'CFP', desc: 'French Franc (Pacific Islands)' },
    { code: 'CHF', desc: 'Swiss Franc' },
    { code: 'CLP', desc: 'Chilean Peso' },
    { code: 'CNY', desc: 'Chinesische Yuan (international)' },
    { code: 'COP', desc: 'Colombian Peso' },
    { code: 'CRC', desc: 'Costa Rica Colon' },
    { code: 'CUP', desc: 'Cuban Peso' },
    { code: 'CVE', desc: 'Cape Verde Escudo' },
    { code: 'CYP', desc: 'Cyprus Pound' },
    { code: 'CZK', desc: 'Czech Krona' },
    { code: 'DEM', desc: 'German Mark' },
    { code: 'DEM3', desc: '(Internal) German Mark (3 dec.places)' },
    { code: 'DJF', desc: 'Djibouti Franc' },
    { code: 'DKK', desc: 'Danish Krone' },
    { code: 'DOP', desc: 'Dominican Peso' },
    { code: 'DZD', desc: 'Algerian Dinar' },
    { code: 'ECS', desc: 'Ecuadorian Sucre (  > USD)' },
    { code: 'EEK', desc: 'Estonian Krone' },
    { code: 'EGP', desc: 'Egyptian Pound' },
    { code: 'ERN', desc: 'Eritrean Nafka' },
    { code: 'ESP', desc: 'Spanish Peseta' },
    { code: 'ETB', desc: 'Ethiopian Birr' },
    { code: 'EUR', desc: 'European Euro' },
    { code: 'FIM', desc: 'Finnish markka' },
    { code: 'FJD', desc: 'Fiji Dollar' },
    { code: 'FKP', desc: 'Falkland Pound' },
    { code: 'FRF', desc: 'French Franc' },
    { code: 'GBP', desc: 'British Pound' },
    { code: 'GEL', desc: 'Georgian Lari' },
    { code: 'GHC', desc: 'Ghanian Cedi' },
    { code: 'GIP', desc: 'Gibraltar Pound' },
    { code: 'GMD', desc: 'Gambian Dalasi' },
    { code: 'GNF', desc: 'Guinean Franc' },
    { code: 'GRD', desc: 'Greek Drachma' },
    { code: 'GTQ', desc: 'Guatemalan Quetzal' },
    { code: 'GWP', desc: 'Guinea Peso' },
    { code: 'GYD', desc: 'Guyana Dollar' },
    { code: 'HKD', desc: 'Hong Kong Dollar' },
    { code: 'HNL', desc: 'Honduran Lempira' },
    { code: 'HRK', desc: 'Croatian Kuna' },
    { code: 'HTG', desc: 'Haitian Gourde' },
    { code: 'HUF', desc: 'Hungarian Forint' },
    { code: 'IDR', desc: 'Indonesian Rupiah' },
    { code: 'IEP', desc: 'Irish Punt' },
    { code: 'ILS', desc: 'Israeli Scheckel' },
    { code: 'INR', desc: 'Indian Rupee' },
    { code: 'IQD', desc: 'Iraqui Dinar' },
    { code: 'IRR', desc: 'Iranian Rial' },
    { code: 'ISK', desc: 'Iceland Krona' },
    { code: 'ITL', desc: 'Italian Lira' },
    { code: 'JMD', desc: 'Jamaican Dollar' },
    { code: 'JOD', desc: 'Jordanian Dinar' },
    { code: 'JPY', desc: 'Japanese Yen' },
    { code: 'KES', desc: 'Kenyan Shilling' },
    { code: 'KGS', desc: 'Kyrgyzstan Som' },
    { code: 'KHR', desc: 'Cambodian Riel' },
    { code: 'KMF', desc: 'Comoros Franc' },
    { code: 'KPW', desc: 'North Korean Won' },
    { code: 'KRW', desc: 'South Korean Won' },
    { code: 'KWD', desc: 'Kuwaiti Dinar' },
    { code: 'KYD', desc: 'Cayman Dollar' },
    { code: 'KZT', desc: 'Kazakstanian Tenge' },
    { code: 'LAK', desc: 'Laotian Kip' },
    { code: 'LBP', desc: 'Lebanese Pound' },
    { code: 'LKR', desc: 'Sri Lankan Rupee' },
    { code: 'LRD', desc: 'Liberian Dollar' },
    { code: 'LSL', desc: 'Lesotho Loti' },
    { code: 'LTL', desc: 'Lithuanian Lita' },
    { code: 'LUF', desc: 'Luxembourg Franc' },
    { code: 'LVL', desc: 'Latvian Lat' },
    { code: 'LYD', desc: 'Libyan Dinar' },
    { code: 'MAD', desc: 'Moroccan Dirham' },
    { code: 'MDL', desc: 'Moldavian Leu' },
    { code: 'MGF', desc: 'Madagascan Franc' },
    { code: 'MKD', desc: 'Macedonian Denar' },
    { code: 'MMK', desc: 'Myanmar Kyat' },
    { code: 'MNT', desc: 'Mongolian Tugrik' },
    { code: 'MOP', desc: 'Macao Pataca' },
    { code: 'MRO', desc: 'Mauritanian Ouguiya' },
    { code: 'MTL', desc: 'Maltese Lira' },
    { code: 'MUR', desc: 'Mauritian Rupee' },
    { code: 'MVR', desc: 'Maldive Rufiyaa' },
    { code: 'MWK', desc: 'Malawi Kwacha' },
    { code: 'MXN', desc: 'Mexican Pesos' },
    { code: 'MYR', desc: 'Malaysian Ringgit' },
    { code: 'MZM', desc: 'Mozambique Metical' },
    { code: 'NAD', desc: 'Namibian Dollar' },
    { code: 'NGN', desc: 'Nigerian Naira' },
    { code: 'NIO', desc: 'Nicaraguan Cordoba Oro' },
    { code: 'NLG', desc: 'Dutch Guilder' },
    { code: 'NOK', desc: 'Norwegian Krone' },
    { code: 'NPR', desc: 'Nepalese Rupee' },
    { code: 'NZD', desc: 'New Zealand Dollars' },
    { code: 'OMR', desc: 'Omani Rial' },
    { code: 'PAB', desc: 'Panamanian Balboa' },
    { code: 'PEN', desc: 'Peruvian New Sol' },
    { code: 'PGK', desc: 'Papua New Guinea Kina' },
    { code: 'PHP', desc: 'Philippine Peso' },
    { code: 'PKR', desc: 'Pakistani Rupee' },
    { code: 'PLN', desc: 'Polish Zloty (new)' },
    { code: 'PTE', desc: 'Portuguese Escudo' },
    { code: 'PYG', desc: 'Paraguayan Guarani' },
    { code: 'QAR', desc: 'Qatar Rial' },
    { code: 'RMB', desc: 'Chinesische Renminbi (national)' },
    { code: 'ROL', desc: 'Romanian Leu' },
    { code: 'RUB', desc: 'Russian Ruble' },
    { code: 'RWF', desc: 'Rwandan Franc' },
    { code: 'SAR', desc: 'Saudi Riyal' },
    { code: 'SBD', desc: 'Solomon Islands Dollar' },
    { code: 'SCR', desc: 'Seychelles Rupee' },
    { code: 'SDD', desc: 'Sudanese Dinar' },
    { code: 'SDP', desc: 'Sudanese Pound' },
    { code: 'SEK', desc: 'Swedish Krona' },
    { code: 'SGD', desc: 'Singapore Dollar' },
    { code: 'SHP', desc: 'St.Helena Pound' },
    { code: 'SIT', desc: 'Slovenian Tolar' },
    { code: 'SKK', desc: 'Slovakian Krona' },
    { code: 'SLL', desc: 'Sierra Leone Leone' },
    { code: 'SOS', desc: 'Somalian Shilling' },
    { code: 'SRG', desc: 'Surinam Guilder' },
    { code: 'STD', desc: 'Sao Tome / Principe Dobra' },
    { code: 'SVC', desc: 'El Salvador Colon' },
    { code: 'SYP', desc: 'Syrian Pound' },
    { code: 'SZL', desc: 'Swaziland Lilangeni' },
    { code: 'THB', desc: 'Thailand Baht' },
    { code: 'TJR', desc: 'Tajikistani Ruble (Old)' },
    { code: 'TJS', desc: 'Tajikistani Somoni' },
    { code: 'TMM', desc: 'Turkmenistani Manat' },
    { code: 'TND', desc: 'Tunisian Dinar' },
    { code: 'TOP', desc: 'Tongan Pa\'anga' },
    { code: 'TPE', desc: 'Timor Escudo' },
    { code: 'TRL', desc: 'Turkish Lira' },
    { code: 'TTD', desc: 'Trinidad and Tobago Dollar' },
    { code: 'TWD', desc: 'New Taiwan Dollar' },
    { code: 'TZS', desc: 'Tanzanian Shilling' },
    { code: 'UAH', desc: 'Ukraine Hryvnia' },
    { code: 'UGX', desc: 'Ugandan Shilling' },
    { code: 'USD', desc: 'United States Dollar' },
    { code: 'USDN', desc: '(Internal) United States Dollar (5 Dec.)' },
    { code: 'UYU', desc: 'Uruguayan Peso (new)' },
    { code: 'UZS', desc: 'Uzbekistan Som' },
    { code: 'VEB', desc: 'Venezuelan Bolivar' },
    { code: 'VND', desc: 'Vietnamese Dong' },
    { code: 'VUV', desc: 'Vanuatu Vatu' },
    { code: 'WST', desc: 'Samoan Tala' },
    { code: 'XAF', desc: 'Gabon CFA Franc BEAC' },
    { code: 'XCD', desc: 'East Carribean Dollar' },
    { code: 'XDS', desc: 'St. Christopher Dollar' },
    { code: 'XEU', desc: 'European Currency Unit (E.C.U.)' },
    { code: 'XOF', desc: 'Benin CFA Franc BCEAO' },
    { code: 'XPF', desc: 'CFP Franc' },
    { code: 'YER', desc: 'Yemeni Ryal' },
    { code: 'YUM', desc: 'New Yugoslavian Dinar' },
    { code: 'ZAR', desc: 'South African Rand' },
    { code: 'ZMK', desc: 'Zambian Kwacha' },
    { code: 'ZRN', desc: 'Zaire (Old)' },
    { code: 'ZWD', desc: 'Zimbabwean Dollar' },
];

const ACCOUNT_GROUP_MAPPING = {
    '1000': ['2400', '2410'],
    '6000': ['2400', '2410'],
    '4800': ['2400', '2410'],
    '5600': ['2410'],
    '5800': ['2500', '2510'],
    '5400': ['2700', '2710']
};

const AdminOnboardingInitiate = () => {
    const [fields, setFields] = useState(initialFields);
    const [formData, setFormData] = useState(getInitialFormData(initialFields));
    const [isEditing, setIsEditing] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const [status, setStatus] = useState({ loading: false, error: null, success: null });
    const [companyOptions, setCompanyOptions] = useState([]);
    const [isLoadingCompanies, setIsLoadingCompanies] = useState(false);
    const [userCompany, setUserCompany] = useState(null);
    const [isSuperAdmin, setIsSuperAdmin] = useState(null); // null initially to track loading state
    const [isCurrencyDropdownOpen, setIsCurrencyDropdownOpen] = useState(false); // 🆕 Currency dropdown state
    const [currencySearch, setCurrencySearch] = useState(''); // 🆕 Currency search state
    const [isIncoDropdownOpen, setIsIncoDropdownOpen] = useState(false);
    const [incoSearch, setIncoSearch] = useState('');
    const [isPaymentTermDropdownOpen, setIsPaymentTermDropdownOpen] = useState(false); // 🆕 Payment Term dropdown state
    const [paymentTermSearch, setPaymentTermSearch] = useState(''); // 🆕 Payment Term search state

    // 🆕 ONB-specific fields state
    const [onbFields, setOnbFields] = useState({
        company_code: '',
        purchasing_organization: '',
        account_group: '',
        terms_of_payment_acc: '',
        payment_term_purch: '',
        order_currency: '',
        incoterms_part_1: '',
        reconciliation_acct: '',
        payment_method: '',
        schema_group: '',
        check_double_invoice: true, // Default checked
        gr_based_inv_verif: true    // Default checked
    });

    // 🆕 STL-Digital specific fields state
    const [stlFields, setStlFields] = useState({
        company_code: '',
        purchasing_organization: '',
        purchasing_organization: '',
        terms_of_payment: '',
        order_currency: '',
        incoterms: '',
        incoterms_part_2: '', // 🆕 Incoterms Location 1
        payment_method: ''
    });

    const [isStlCompanyCodeDropdownOpen, setIsStlCompanyCodeDropdownOpen] = useState(false);
    const [isStlPurchasingOrgDropdownOpen, setIsStlPurchasingOrgDropdownOpen] = useState(false);
    const [isStlPaymentTermDropdownOpen, setIsStlPaymentTermDropdownOpen] = useState(false);
    const [stlPaymentTermSearch, setStlPaymentTermSearch] = useState('');
    const [isStlCurrencyDropdownOpen, setIsStlCurrencyDropdownOpen] = useState(false);
    const [stlCurrencySearch, setStlCurrencySearch] = useState('');
    const [isStlIncoTermDropdownOpen, setIsStlIncoTermDropdownOpen] = useState(false);
    const [stlIncoTermSearch, setStlIncoTermSearch] = useState('');
    const [isStlPaymentMethodDropdownOpen, setIsStlPaymentMethodDropdownOpen] = useState(false);
    const [stlPaymentMethodSearch, setStlPaymentMethodSearch] = useState('');

    const fetchFields = async () => {
        try {
            const response = await api.get('/api/vendor-fields/');
            const fetchedFields = response.data || [];

            // ✅ Merge API fields with initial defaults instead of replacing
            const mergedFields = [...initialFields];
            fetchedFields.forEach(apiField => {
                const existingIndex = mergedFields.findIndex(f => f.key === apiField.key);
                if (existingIndex >= 0) {
                    // Update existing field with server data
                    mergedFields[existingIndex] = { ...mergedFields[existingIndex], ...apiField };
                } else {
                    // Add new field from server
                    mergedFields.push(apiField);
                }
            });

            setFields(mergedFields);
            // Preserve any pre-set company (e.g., locked ONB) when fields load
            setFormData(prev => {
                const base = getInitialFormData(mergedFields);
                // ✅ FIX: Preserve ALL existing input values, not just company
                return { ...base, ...prev };
            });
        } catch (err) {
            // Failed to fetch fields
            setFields(initialFields);
            setFormData(prev => {
                const base = getInitialFormData(initialFields);
                const lockedCompany = prev.company || userCompany || '';
                return { ...base, company: lockedCompany };
            });
        }
    };

    // Fetch user's company from permissions API
    const fetchUserCompany = useCallback(async () => {
        try {
            const response = await api.get('/api/user-permissions/');
            const data = response.data || {};
            const superAdmin = !!data.isSuperAdmin;
            setIsSuperAdmin(superAdmin);

            // If not super admin, get the effective company
            if (!superAdmin && data.effectiveCompany) {
                const company = String(data.effectiveCompany || '').trim();
                if (company) {
                    setUserCompany(company);
                    // Set as default in form data
                    setFormData(prev => ({ ...prev, company: company }));
                } else {
                    setUserCompany(''); // Set empty string to indicate no company
                }
            } else {
                setUserCompany(''); // Set empty string for super admin or no company
            }
        } catch (err) {
            // Failed to fetch user company
            setIsSuperAdmin(false);
            setUserCompany('');
        }
    }, []);

    const fetchCompanies = useCallback(async () => {
        setIsLoadingCompanies(true);
        try {
            // If user has a specific company, only fetch that company
            if (userCompany && !isSuperAdmin) {
                // Only show the user's company
                setCompanyOptions([userCompany]);
            } else {
                // Super admin or no company restriction - fetch all companies
                const response = await api.get('/api/companies/');
                const names = Array.isArray(response.data)
                    ? response.data
                        .map(company => company?.name)
                        .filter(Boolean)
                    : [];
                setCompanyOptions(names);
            }
        } catch (err) {
            // Failed to fetch companies
            // If user has a company, still set it even if API fails
            if (userCompany && !isSuperAdmin) {
                setCompanyOptions([userCompany]);
            } else {
                setCompanyOptions([]);
            }
        } finally {
            setIsLoadingCompanies(false);
        }
    }, [userCompany, isSuperAdmin]);

    useEffect(() => {
        fetchFields();
        fetchUserCompany();

        if (status.success) {
            const timer = setTimeout(() => {
                setStatus(prev => ({ ...prev, success: null }));
            }, 3000);
            return () => clearTimeout(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status.success, fetchUserCompany]);

    // Fetch companies after user company is determined
    useEffect(() => {
        // Only fetch companies after we know if user is super admin or has a company
        if (isSuperAdmin !== null) {
            fetchCompanies();
        }
    }, [userCompany, isSuperAdmin, fetchCompanies]);

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }, []);

    // 🆕 Handle ONB fields change
    const handleOnbFieldChange = useCallback((e) => {
        const { name, value, type, checked } = e.target;
        setOnbFields(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    }, []);

    // 🆕 Handle STL fields change
    const handleStlFieldChange = useCallback((e) => {
        const { name, value } = e.target;

        let updates = { [name]: value };

        // Sync Company Code and Purchasing Organization
        if (name === 'company_code') {
            updates['purchasing_organization'] = value;
        } else if (name === 'purchasing_organization') {
            updates['company_code'] = value;
        }

        setStlFields(prev => ({
            ...prev,
            ...updates
        }));
    }, []);

    const handleLabelChange = (id, newLabel) => {
        setFields(prev => prev.map(field => field.id === id ? { ...field, label: newLabel } : field));
        setHasChanges(true);
    };

    const handleAddField = () => {
        const newField = {
            id: nextId++,
            key: `custom_field_${Date.now()}`, // Use timestamp for unique key
            label: 'New Custom Field',
            required: false,
            field_type: 'text', // Use field_type instead of type
            removable: true,
        };
        setIsEditing(true); // ensure we're in editing mode
        setFields(prev => [...prev, newField]);
        setFormData(prev => ({ ...prev, [newField.key]: '' }));
        setHasChanges(true);
    };

    const handleRemoveField = (id) => {
        setFields(prev => prev.filter(f => f.id !== id));
        setHasChanges(true);
    };

    const handleEditClick = () => {
        setIsEditing(true);
        setStatus({ loading: false, error: null, success: null });
    };

    const handleCancel = async () => {
        setIsEditing(false);
        setHasChanges(false);
        // Reset fields to original state by fetching from server
        try {
            await fetchFields();
        } catch (error) {
            // Failed to reset fields
        }
    };

    const handleSave = async () => {
        setStatus({ loading: true, error: null, success: null });
        try {
            // Filter out fields that don't have proper IDs (new fields)
            const fieldsToSave = fields.filter(field => field.id && field.id > 0);
            await api.post('/api/vendor-fields/save/', fieldsToSave);
            setStatus({ loading: false, success: 'Configuration saved successfully!', error: null });
            setIsEditing(false);
            setHasChanges(false);
            // Refresh fields from server to get updated data
            await fetchFields();
        } catch (error) {
            // Save error occurred
            const errorMessage = error.response?.data?.error ||
                error.response?.data?.detail ||
                'Failed to save configuration';
            setStatus({ loading: false, error: errorMessage, success: null });
        }
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        const vendorName = (formData.vendor_name || '').trim();
        const vendorEmail = (formData.vendor_email || '').trim();
        const company = (formData.company || '').trim();

        if (!company) {
            setStatus({ loading: false, error: 'Please select a vendor company.', success: null });
            return;
        }

        if (!vendorEmail || !vendorEmail.includes('@')) {
            setStatus({ loading: false, error: 'Please enter a valid email address.', success: null });
            return;
        }

        // 🆕 ONB-specific validation
        if (company === 'ONB') {
            const requiredOnbFields = [
                { key: 'company_code', label: 'Company Code' },
                { key: 'purchasing_organization', label: 'Purchasing Organization' },
                { key: 'account_group', label: 'Account Group' },
                { key: 'terms_of_payment_acc', label: 'Terms Of Payment(Acc)' },
                { key: 'order_currency', label: 'Order Currency' },
                { key: 'incoterms_part_1', label: 'Incoterms Part 1' },
            ];

            for (const field of requiredOnbFields) {
                if (!onbFields[field.key] || onbFields[field.key].trim() === '') {
                    setStatus({
                        loading: false,
                        error: `${field.label} is required for ONB company. Please fill all ONB fields.`,
                        success: null
                    });
                    return;
                }
            }

            if (onbFields.company_code !== onbFields.purchasing_organization) {
                setStatus({
                    loading: false,
                    error: 'Company Code and Purchasing Organization must be the same value.',
                    success: null
                });
                return;
            }
        }

        // 🆕 STL-Digital Validation
        if (company.trim().replace('-', '').toLowerCase() === 'stldigital' || company.trim().toLowerCase() === 'stl-digital') {
            const requiredStlFields = [
                { key: 'company_code', label: 'Company Code' },
                { key: 'purchasing_organization', label: 'Purchasing Organization' },
                { key: 'terms_of_payment', label: 'Payment Terms' },
                { key: 'order_currency', label: 'Order Currency' },
                { key: 'incoterms', label: 'Inco Terms' },
                // { key: 'payment_method', label: 'Payment Method' }, // Optional for STL-Digital
            ];

            for (const field of requiredStlFields) {
                if (!stlFields[field.key] || stlFields[field.key].trim() === '') {
                    setStatus({
                        loading: false,
                        error: `${field.label} is required for STL-Digital. Please fill all fields.`,
                        success: null
                    });
                    return;
                }
            }

            // 🆕 Conditional Validation for Incoterms Locations
            if (stlFields.incoterms && stlFields.incoterms !== 'NA') {
                if (!stlFields.incoterms_part_2 || stlFields.incoterms_part_2.trim() === '') {
                    setStatus({
                        loading: false,
                        error: 'Incoterms Location 1 is required when Inco Terms is not NA.',
                        success: null
                    });
                    return;
                }

            }
        }


        setStatus({ loading: true, error: null, success: null });

        try {
            // 🆕 Filter out standard keys to identify dynamic custom fields
            const standardKeys = ['vendor_name', 'vendor_email', 'company', 'gst_number'];
            const dynamicFields = {};

            Object.keys(formData).forEach(key => {
                if (!standardKeys.includes(key) && formData[key] && String(formData[key]).trim() !== '') {
                    dynamicFields[key] = formData[key];
                }
            });

            const payload = {
                vendor_name: vendorName,      // ✅ backend expects this
                vendor_email: vendorEmail,    // ✅ backend expects this
                company: company,             // ✅ backend expects this
                category: company,            // Use selected company for category
                gst_number: formData.gst_number || '', // 🆕 Send GST Number
                dynamic_fields: dynamicFields // 🆕 Send Custom Fields
            };

            // 🆕 Add ONB fields if company is ONB
            if (company === 'ONB') {
                payload.onb_fields = onbFields;
            }

            // 🆕 Add STL fields if company is STL-Digital
            if (company.trim().replace('-', '').toLowerCase() === 'stldigital' || company.trim().toLowerCase() === 'stl-digital') {
                payload.stldigital_fields = stlFields;
            }

            await api.post('/api/vendor/send-registration-email/', payload);

            setStatus({
                loading: false,
                success: `Onboarding email successfully sent to ${vendorEmail}.`,
                error: null
            });

            // Reset form including ONB fields
            const resetData = getInitialFormData(fields);
            if (userCompany && !isSuperAdmin) {
                resetData.company = userCompany;
            }
            setFormData(resetData);
            setOnbFields({
                company_code: '',
                purchasing_organization: '',
                account_group: '',
                terms_of_payment_acc: '',
                payment_term_purch: '',
                order_currency: '',
                incoterms_part_1: '',
                reconciliation_acct: '',
                payment_method: '',
                schema_group: '',
                check_double_invoice: true,
                gr_based_inv_verif: true
            });
            setStlFields({
                company_code: '',
                purchasing_organization: '',
                terms_of_payment: '',
                order_currency: '',
                incoterms: '',
                payment_method: ''
            });
        } catch (error) {
            // Onboarding initiation failed
            const errorMessage =
                error.response?.data?.error ||
                error.response?.data?.detail ||
                'Failed to initiate vendor onboarding. Please try again.';
            setStatus({ loading: false, error: errorMessage, success: null });
        }
    };

    return (
        <div className="onboarding-container">
            <div className="status-notification-area">
                {status.success && <div className="status-message success"><span>{status.success}</span></div>}
                {status.error && <div className="status-message error"><span>{status.error}</span></div>}
            </div>

            <div className="onboarding-card">
                <div className="form-header">
                    <div className="form-title-section">
                        <h2>Vendor Onboarding Form</h2>
                        <p>{isEditing ? "Configure labels and fields" : ""}</p>
                    </div>
                    <div className="form-actions">
                        {isEditing && hasChanges && (
                            <button className="btn-action btn-save" onClick={handleSave} disabled={status.loading}>
                                {status.loading ? 'Saving...' : 'Save Changes'}
                            </button>
                        )}
                        {isEditing && (
                            <button className="btn-action btn-cancel" onClick={handleCancel}>Cancel</button>
                        )}
                        <button className="btn-edit-icon" onClick={handleEditClick} disabled={isEditing} title="Edit Configuration">
                            <SettingsIcon size={20} />
                        </button>
                    </div>
                </div>


                <form onSubmit={handleFormSubmit} className="onboarding-form">
                    {fields.map(field => {
                        // 🆕 Hide Company field for non-superadmins (Admins with specific company access)
                        if (field.key === 'company' && isSuperAdmin === false) {
                            return null;
                        }

                        return (
                            <div key={field.id} className="form-group-wrapper">
                                {isEditing && field.removable && <TrashIcon className="trash-icon clickable" onClick={() => handleRemoveField(field.id)} />}
                                <div className="form-group">
                                    <label htmlFor={field.key} className="form-label">
                                        {field.label} {field.required && <span className="text-red-500">*</span>}
                                    </label>
                                    {(!isEditing && field.key === 'company') ? (
                                        <div style={{ position: 'relative', width: '100%' }}>
                                            <select
                                                id={field.key}
                                                name={field.key}
                                                required={field.required}
                                                value={formData[field.key] || ''}
                                                onChange={handleChange}
                                                className="form-input form-select"
                                                disabled={status.loading || (!isSuperAdmin && userCompany)}
                                                style={{
                                                    appearance: 'none',
                                                    WebkitAppearance: 'none',
                                                    MozAppearance: 'none',
                                                    paddingRight: '30px',
                                                    width: '100%',
                                                    backgroundColor: ((!isSuperAdmin && userCompany) || status.loading) ? '#f3f4f6' : '#fff',
                                                    cursor: ((!isSuperAdmin && userCompany) || status.loading) ? 'not-allowed' : 'pointer',
                                                    opacity: ((!isSuperAdmin && userCompany) || status.loading) ? 0.8 : 1,
                                                }}
                                            >
                                                {isLoadingCompanies ? (
                                                    <option value="">Loading companies...</option>
                                                ) : !isSuperAdmin && userCompany ? (
                                                    <option value={userCompany}>{userCompany}</option>
                                                ) : companyOptions.length > 0 ? (
                                                    <>
                                                        <option value="" disabled>
                                                            Select Company
                                                        </option>
                                                        {companyOptions.map(option => (
                                                            <option key={option} value={option}>
                                                                {option}
                                                            </option>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <option value="">No companies available</option>
                                                )}
                                            </select>

                                            {/* Dropdown Arrow */}
                                            <FaChevronDown style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#6b7280',
                                                pointerEvents: 'none',
                                                fontSize: '12px'
                                            }} />

                                            {/* Lock Icon for Non-Admin */}
                                            {!isSuperAdmin && userCompany && (
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        right: '30px', // Shift left to avoid overlap with arrow
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        color: '#6b7280',
                                                        fontSize: '14px',
                                                        pointerEvents: 'none'
                                                    }}
                                                    title="Company is locked to your assigned company"
                                                >
                                                    🔒
                                                </span>
                                            )}
                                        </div>
                                    ) : (
                                        <input
                                            id={field.key}
                                            name={field.key}
                                            type={field.field_type || field.type || 'text'}
                                            required={field.required}
                                            value={
                                                isEditing
                                                    ? field.label // show editable label during edit mode
                                                    : formData[field.key] || '' // show actual form value during normal mode
                                            }
                                            onChange={(e) => {
                                                if (isEditing && field.removable) {
                                                    handleLabelChange(field.id, e.target.value); // allow editing label
                                                } else if (!isEditing) {
                                                    handleChange(e); // allow normal form input change
                                                }
                                            }}
                                            disabled={status.loading} // Disable input during loading
                                            readOnly={isEditing && !field.removable} // Read-only for locked fields in edit mode
                                            className={`form-input ${(isEditing && !field.removable) ? 'input-readonly' : ''}`}
                                            placeholder={field.label}
                                        />
                                    )}

                                </div>
                            </div>
                        );
                    })}

                    {/* 🆕 ONB-specific fields - Show when ONB is selected */}
                    {!isEditing && formData.company === 'ONB' && (
                        <div className="onb-fields-section" style={{ position: 'relative', zIndex: 20 }}>
                            <div className="onb-fields-header">
                                <h3>ONB-Specific Fields</h3>
                                <p>Additional fields required for ONB company</p>
                            </div>

                            {/* Row 1: Company Code, Purchasing Organization */}
                            <div className="onb-fields-row">
                                <div className="form-group">
                                    <label htmlFor="company_code" className="form-label">
                                        Company Code <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id="company_code"
                                            name="company_code"
                                            required
                                            value={onbFields.company_code}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                // Validate manual change handling - update BOTH
                                                setOnbFields(prev => ({
                                                    ...prev,
                                                    company_code: val,
                                                    purchasing_organization: val,
                                                    account_group: '' // Reset account group on company change
                                                }));
                                            }}
                                            className="form-input form-select"
                                            disabled={status.loading}
                                            style={{ appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none', paddingRight: '30px' }}
                                        >
                                            <option value="">Select Company Code</option>
                                            <option value="1000">1000</option>
                                            <option value="6000">6000</option>
                                            <option value="4800">4800</option>
                                            <option value="5400">5400</option>
                                            <option value="5600">5600</option>
                                            <option value="5800">5800</option>
                                        </select>
                                        <FaChevronDown style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#6b7280',
                                            pointerEvents: 'none',
                                            fontSize: '12px'
                                        }} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="purchasing_organization" className="form-label">
                                        Purchasing Organization <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id="purchasing_organization"
                                            name="purchasing_organization"
                                            required
                                            value={onbFields.purchasing_organization}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                // Validate manual change handling - update BOTH
                                                setOnbFields(prev => ({
                                                    ...prev,
                                                    purchasing_organization: val,
                                                    company_code: val,
                                                    account_group: '' // Reset account group on company change
                                                }));
                                            }}
                                            className="form-input form-select"
                                            disabled={status.loading}
                                            style={{ appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none', paddingRight: '30px' }}
                                        >
                                            <option value="">Select Purchasing Org</option>
                                            <option value="1000">1000</option>
                                            <option value="6000">6000</option>
                                            <option value="4800">4800</option>
                                            <option value="5400">5400</option>
                                            <option value="5600">5600</option>
                                            <option value="5800">5800</option>
                                        </select>
                                        <FaChevronDown style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#6b7280',
                                            pointerEvents: 'none',
                                            fontSize: '12px'
                                        }} />
                                    </div>
                                </div>
                            </div>

                            {/* Row 2: Account Group, Terms Of Payment(Acc) */}
                            <div className="onb-fields-row">
                                <div className="form-group">
                                    <label htmlFor="account_group" className="form-label">
                                        Account Group <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <select
                                            id="account_group"
                                            name="account_group"
                                            required
                                            value={onbFields.account_group}
                                            onChange={handleOnbFieldChange}
                                            className="form-input form-select"
                                            disabled={status.loading}
                                            style={{ appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none', paddingRight: '30px', marginTop: '-5px' }}
                                        >

                                            <option value="">Select Account Group</option>
                                            {(ACCOUNT_GROUP_MAPPING[onbFields.company_code] || []).map(opt => (
                                                <option key={opt} value={opt}>{opt}</option>
                                            ))}
                                        </select>
                                        <FaChevronDown style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#6b7280',
                                            pointerEvents: 'none',
                                            fontSize: '12px'
                                        }} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="terms_of_payment_acc" className="form-label">
                                        Terms Of Payment(Acc) <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => {
                                                if (!status.loading) {
                                                    setIsPaymentTermDropdownOpen(!isPaymentTermDropdownOpen);
                                                    setPaymentTermSearch(''); // Clear search on open/toggle
                                                }
                                            }}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                paddingRight: '12px',
                                                minHeight: '42px',
                                                marginTop: '-5px'
                                            }}
                                        >
                                            <span style={{ color: onbFields.terms_of_payment_acc ? '#374151' : '#9ca3af' }}>
                                                {onbFields.terms_of_payment_acc || 'Select Payment Term'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>

                                        {isPaymentTermDropdownOpen && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                maxHeight: '250px',
                                                overflowY: 'auto',
                                                backgroundColor: '#fff',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '0.375rem',
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                zIndex: 100, // High z-index to overlap content below
                                                marginTop: '4px'
                                            }}>
                                                {/* Search Field */}
                                                <div style={{
                                                    padding: '8px',
                                                    position: 'sticky',
                                                    top: 0,
                                                    backgroundColor: '#fff',
                                                    zIndex: 20,
                                                    borderBottom: '1px solid #e5e7eb'
                                                }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Search payment term..."
                                                        value={paymentTermSearch}
                                                        onChange={(e) => setPaymentTermSearch(e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        autoFocus
                                                        style={{
                                                            width: '100%',
                                                            padding: '6px 10px',
                                                            borderRadius: '4px',
                                                            border: '1px solid #d1d5db',
                                                            fontSize: '14px',
                                                            outline: 'none'
                                                        }}
                                                    />
                                                </div>

                                                {/* Header */}
                                                <div style={{
                                                    display: 'flex',
                                                    padding: '8px 12px',
                                                    backgroundColor: '#f9fafb',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    fontWeight: '600',
                                                    fontSize: '12px',
                                                    color: '#374151',
                                                    // Sticky below search
                                                    position: 'sticky',
                                                    top: '45px', // Approx height of search div
                                                    zIndex: 10
                                                }}>
                                                    <div style={{ flex: '0 0 80px' }}>Term</div>
                                                    <div style={{ flex: 1 }}>Description</div>
                                                </div>

                                                {/* List */}
                                                {paymentTermsList.filter(t =>
                                                    t.code.toLowerCase().includes(paymentTermSearch.toLowerCase()) ||
                                                    t.desc.toLowerCase().includes(paymentTermSearch.toLowerCase())
                                                ).length > 0 ? (
                                                    paymentTermsList
                                                        .filter(t =>
                                                            t.code.toLowerCase().includes(paymentTermSearch.toLowerCase()) ||
                                                            t.desc.toLowerCase().includes(paymentTermSearch.toLowerCase())
                                                        )
                                                        .map((term) => (
                                                            <div
                                                                key={term.code}
                                                                onClick={() => {
                                                                    handleOnbFieldChange({ target: { name: 'terms_of_payment_acc', value: term.code } });
                                                                    setIsPaymentTermDropdownOpen(false);
                                                                    setPaymentTermSearch('');
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #f3f4f6',
                                                                    backgroundColor: onbFields.terms_of_payment_acc === term.code ? '#eff6ff' : 'transparent',
                                                                    fontSize: '14px',
                                                                    color: '#374151'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = onbFields.terms_of_payment_acc === term.code ? '#eff6ff' : 'transparent'}
                                                            >
                                                                <div style={{ flex: '0 0 80px', fontWeight: '500' }}>{term.code}</div>
                                                                <div style={{ flex: 1, color: '#6b7280', whiteSpace: 'pre-wrap' }}>{term.desc}</div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div style={{ padding: '12px', textAlign: 'center', color: '#9ca3af', fontSize: '14px' }}>
                                                        No results found
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Overlay to close dropdown when clicking outside */}
                                        {isPaymentTermDropdownOpen && (
                                            <div
                                                style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }}
                                                onClick={() => {
                                                    setIsPaymentTermDropdownOpen(false);
                                                    setPaymentTermSearch('');
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Row 3: Order Currency, Incoterms Part 1 */}
                            <div className="onb-fields-row">
                                <div className="form-group">
                                    <label htmlFor="order_currency" className="form-label">
                                        Order Currency <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => {
                                                if (!status.loading) {
                                                    setIsCurrencyDropdownOpen(!isCurrencyDropdownOpen);
                                                    setCurrencySearch(''); // Clear search on open/toggle
                                                }
                                            }}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                paddingRight: '12px',
                                                minHeight: '42px'
                                            }}
                                        >
                                            <span style={{ color: onbFields.order_currency ? '#374151' : '#9ca3af' }}>
                                                {onbFields.order_currency || 'Select Currency'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>

                                        {isCurrencyDropdownOpen && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                maxHeight: '155px',
                                                overflowY: 'auto',
                                                backgroundColor: '#fff',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '0.375rem',
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                zIndex: 100, // High z-index to overlap button
                                                marginTop: '4px'
                                            }}>
                                                {/* Search Field */}
                                                <div style={{
                                                    padding: '8px',
                                                    position: 'sticky',
                                                    top: 0,
                                                    backgroundColor: '#fff',
                                                    zIndex: 20,
                                                    borderBottom: '1px solid #e5e7eb'
                                                }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Search currency..."
                                                        value={currencySearch}
                                                        onChange={(e) => setCurrencySearch(e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        autoFocus
                                                        style={{
                                                            width: '100%',
                                                            padding: '6px 10px',
                                                            borderRadius: '4px',
                                                            border: '1px solid #d1d5db',
                                                            fontSize: '14px',
                                                            outline: 'none'
                                                        }}
                                                    />
                                                </div>

                                                {/* Header */}
                                                <div style={{
                                                    display: 'flex',
                                                    padding: '8px 12px',
                                                    backgroundColor: '#f9fafb',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    fontWeight: '600',
                                                    fontSize: '12px',
                                                    color: '#374151',
                                                    // Sticky below search
                                                    position: 'sticky',
                                                    top: '45px', // Approx height of search div
                                                    zIndex: 10
                                                }}>
                                                    <div style={{ flex: '0 0 80px' }}>Currency</div>
                                                    <div style={{ flex: 1 }}>Description</div>
                                                </div>

                                                {/* List */}
                                                {currencyList.filter(c =>
                                                    c.code.toLowerCase().includes(currencySearch.toLowerCase()) ||
                                                    c.desc.toLowerCase().includes(currencySearch.toLowerCase())
                                                ).length > 0 ? (
                                                    currencyList
                                                        .filter(c =>
                                                            c.code.toLowerCase().includes(currencySearch.toLowerCase()) ||
                                                            c.desc.toLowerCase().includes(currencySearch.toLowerCase())
                                                        )
                                                        .map((currency) => (
                                                            <div
                                                                key={currency.code}
                                                                onClick={() => {
                                                                    handleOnbFieldChange({ target: { name: 'order_currency', value: currency.code } });
                                                                    setIsCurrencyDropdownOpen(false);
                                                                    setCurrencySearch('');
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #f3f4f6',
                                                                    backgroundColor: onbFields.order_currency === currency.code ? '#eff6ff' : 'transparent',
                                                                    fontSize: '14px',
                                                                    color: '#374151'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = onbFields.order_currency === currency.code ? '#eff6ff' : 'transparent'}
                                                            >
                                                                <div style={{ flex: '0 0 80px', fontWeight: '500' }}>{currency.code}</div>
                                                                <div style={{ flex: 1, color: '#6b7280' }}>{currency.desc}</div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div style={{ padding: '12px', textAlign: 'center', color: '#9ca3af', fontSize: '14px' }}>
                                                        No results found
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Overlay to close dropdown when clicking outside */}
                                        {isCurrencyDropdownOpen && (
                                            <div
                                                style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }}
                                                onClick={() => {
                                                    setIsCurrencyDropdownOpen(false);
                                                    setCurrencySearch('');
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="incoterms_part_1" className="form-label">
                                        Incoterms Part 1 <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => {
                                                if (!status.loading) {
                                                    setIsIncoDropdownOpen(!isIncoDropdownOpen);
                                                    setIncoSearch('');
                                                }
                                            }}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                paddingRight: '12px',
                                                minHeight: '42px'
                                            }}
                                        >
                                            <span style={{ color: onbFields.incoterms_part_1 ? '#374151' : '#9ca3af' }}>
                                                {onbFields.incoterms_part_1 || 'Select Term'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>

                                        {isIncoDropdownOpen && (
                                            <div style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                maxHeight: '155px',
                                                overflowY: 'auto',
                                                backgroundColor: '#fff',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '0.375rem',
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                zIndex: 100,
                                                marginTop: '4px'
                                            }}>
                                                {/* Search Field */}
                                                <div style={{
                                                    padding: '8px',
                                                    position: 'sticky',
                                                    top: 0,
                                                    backgroundColor: '#fff',
                                                    zIndex: 20,
                                                    borderBottom: '1px solid #e5e7eb'
                                                }}>
                                                    <input
                                                        type="text"
                                                        placeholder="Search term..."
                                                        value={incoSearch}
                                                        onChange={(e) => setIncoSearch(e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        autoFocus
                                                        style={{
                                                            width: '100%',
                                                            padding: '6px 10px',
                                                            borderRadius: '4px',
                                                            border: '1px solid #d1d5db',
                                                            fontSize: '14px',
                                                            outline: 'none'
                                                        }}
                                                    />
                                                </div>

                                                {/* Header */}
                                                <div style={{
                                                    display: 'flex',
                                                    padding: '8px 12px',
                                                    backgroundColor: '#f9fafb',
                                                    borderBottom: '1px solid #e5e7eb',
                                                    fontSize: '12px',
                                                    fontWeight: '600',
                                                    color: '#6b7280',
                                                    position: 'sticky',
                                                    top: '41px', // Height of search input + padding
                                                    zIndex: 10
                                                }}>
                                                    <div style={{ width: '80px', flexShrink: 0 }}>Term</div>
                                                    <div style={{ flex: 1 }}>Description</div>
                                                </div>

                                                {/* List */}
                                                {incotermsList.filter((item) => {
                                                    const searchLower = incoSearch.toLowerCase();
                                                    return (
                                                        item.code.toLowerCase().includes(searchLower) ||
                                                        item.desc.toLowerCase().includes(searchLower)
                                                    );
                                                }).length > 0 ? (
                                                    incotermsList
                                                        .filter((item) => {
                                                            const searchLower = incoSearch.toLowerCase();
                                                            return (
                                                                item.code.toLowerCase().includes(searchLower) ||
                                                                item.desc.toLowerCase().includes(searchLower)
                                                            );
                                                        })
                                                        .map((item) => (
                                                            <div
                                                                key={item.code}
                                                                onClick={() => {
                                                                    handleOnbFieldChange({ target: { name: 'incoterms_part_1', value: item.code } });
                                                                    setIsIncoDropdownOpen(false);
                                                                    setIncoSearch('');
                                                                }}
                                                                style={{
                                                                    display: 'flex',
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #f3f4f6',
                                                                    backgroundColor: onbFields.incoterms_part_1 === item.code ? '#eff6ff' : 'transparent',
                                                                    fontSize: '14px',
                                                                    color: '#374151'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = onbFields.incoterms_part_1 === item.code ? '#eff6ff' : 'transparent'}
                                                            >
                                                                <div style={{ width: '80px', flexShrink: 0, fontWeight: '500' }}>{item.code}</div>
                                                                <div style={{ flex: 1, color: '#6b7280' }}>{item.desc}</div>
                                                            </div>
                                                        ))
                                                ) : (
                                                    <div style={{ padding: '12px', textAlign: 'center', color: '#9ca3af', fontSize: '14px' }}>
                                                        No results found
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Overlay to close dropdown when clicking outside */}
                                        {isIncoDropdownOpen && (
                                            <div
                                                style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }}
                                                onClick={() => {
                                                    setIsIncoDropdownOpen(false);
                                                    setIncoSearch('');
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* 🆕 STL-Digital Specific Fields - Rendered only when STL-Digital company is selected */}
                    {(formData.company && (formData.company.trim().replace('-', '').toLowerCase() === 'stldigital' || formData.company.trim().toLowerCase() === 'stl-digital')) && (
                        <div className="onb-fields-section" style={{ position: 'relative', zIndex: 20 }}>
                            <div className="onb-fields-header">
                                <h3>STL-Digital Specific Fields</h3>
                                <p>Additional fields required for STL-Digital company</p>
                            </div>

                            {/* Row 1: Company Code, Purchasing Organization */}
                            <div className="onb-fields-row">
                                <div className="form-group">
                                    <label className="form-label">
                                        Company Code <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => !status.loading && setIsStlCompanyCodeDropdownOpen(!isStlCompanyCodeDropdownOpen)}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                paddingRight: '30px',
                                                marginTop: '-5px'
                                            }}
                                        >
                                            <span style={{ color: stlFields.company_code ? '#374151' : '#9ca3af' }}>
                                                {/* Show ONLY value to match ONB 1000/2000 style */}
                                                {stlFields.company_code ? stlFields.company_code : 'Select Company Code'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>
                                        {isStlCompanyCodeDropdownOpen && (
                                            <>
                                                <div className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    width: '100%',
                                                    zIndex: 50,
                                                    border: '1px solid #d1d5db',
                                                    backgroundColor: '#fff',
                                                    borderRadius: '0.375rem',
                                                    maxHeight: '200px',
                                                    overflowY: 'auto',
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                                                    marginTop: '4px'
                                                }}>
                                                    {stlDigitalCompanyCodeList.map(item => (
                                                        <div
                                                            key={item.value}
                                                            className="dropdown-item"
                                                            style={{
                                                                padding: '8px 12px',
                                                                cursor: 'pointer',
                                                                borderBottom: '1px solid #f3f4f6',
                                                                fontSize: '14px',
                                                                color: '#374151',
                                                                backgroundColor: stlFields.company_code === item.value ? '#eff6ff' : 'transparent'
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = stlFields.company_code === item.value ? '#eff6ff' : 'transparent'}
                                                            onClick={() => {
                                                                handleStlFieldChange({ target: { name: 'company_code', value: item.value } });
                                                                setIsStlCompanyCodeDropdownOpen(false);
                                                            }}
                                                        >
                                                            {/* Show Label in Dropdown (e.g. 1000 - STL Digital Ltd.) or just Value? User asked for values. Let's show label for context but select value. */}
                                                            {item.label}
                                                        </div>
                                                    ))}
                                                </div>
                                                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }} onClick={() => setIsStlCompanyCodeDropdownOpen(false)} />
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">
                                        Purchasing Organization <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => !status.loading && setIsStlPurchasingOrgDropdownOpen(!isStlPurchasingOrgDropdownOpen)}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                paddingRight: '30px',
                                                marginTop: '-5px'
                                            }}
                                        >
                                            <span style={{ color: stlFields.purchasing_organization ? '#374151' : '#9ca3af' }}>
                                                {/* Show ONLY value */}
                                                {stlFields.purchasing_organization ? stlFields.purchasing_organization : 'Select Purchasing Org'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>
                                        {isStlPurchasingOrgDropdownOpen && (
                                            <>
                                                <div className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    width: '100%',
                                                    zIndex: 50,
                                                    border: '1px solid #d1d5db',
                                                    backgroundColor: '#fff',
                                                    borderRadius: '0.375rem',
                                                    maxHeight: '200px',
                                                    overflowY: 'auto',
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
                                                    marginTop: '4px'
                                                }}>
                                                    {stlDigitalPurchasingOrgList.map(item => (
                                                        <div
                                                            key={item.value}
                                                            className="dropdown-item"
                                                            style={{
                                                                padding: '8px 12px',
                                                                cursor: 'pointer',
                                                                borderBottom: '1px solid #f3f4f6',
                                                                fontSize: '14px',
                                                                color: '#374151',
                                                                backgroundColor: stlFields.purchasing_organization === item.value ? '#eff6ff' : 'transparent'
                                                            }}
                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = stlFields.purchasing_organization === item.value ? '#eff6ff' : 'transparent'}
                                                            onClick={() => {
                                                                handleStlFieldChange({ target: { name: 'purchasing_organization', value: item.value } });
                                                                setIsStlPurchasingOrgDropdownOpen(false);
                                                            }}
                                                        >
                                                            {item.label}
                                                        </div>
                                                    ))}
                                                </div>
                                                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }} onClick={() => setIsStlPurchasingOrgDropdownOpen(false)} />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Row 2: Payment Terms, Order Currency */}
                            <div className="onb-fields-row">
                                <div className="form-group">
                                    <label className="form-label">
                                        Payment Terms <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => {
                                                if (!status.loading) {
                                                    setIsStlPaymentTermDropdownOpen(!isStlPaymentTermDropdownOpen);
                                                    setStlPaymentTermSearch('');
                                                }
                                            }}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                minHeight: '42px',
                                                paddingRight: '12px'
                                            }}
                                        >
                                            <span style={{
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                color: stlFields.terms_of_payment ? '#374151' : '#9ca3af'
                                            }}>
                                                {stlFields.terms_of_payment || 'Select Payment Term'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>
                                        {isStlPaymentTermDropdownOpen && (
                                            <>
                                                <div className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    width: 'max-content',
                                                    minWidth: '100%',
                                                    maxWidth: '350px',
                                                    zIndex: 100, // High z-index to overlap content below
                                                    border: '1px solid #d1d5db',
                                                    backgroundColor: '#fff',
                                                    borderRadius: '0.375rem',
                                                    maxHeight: '250px',
                                                    overflowY: 'auto',
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                    marginTop: '4px'
                                                }}>
                                                    <div style={{ position: 'sticky', top: 0, backgroundColor: '#fff', padding: '8px', borderBottom: '1px solid #e5e7eb', zIndex: 20 }}>
                                                        <input
                                                            type="text"
                                                            placeholder="Search payment term..."
                                                            value={stlPaymentTermSearch}
                                                            onChange={(e) => setStlPaymentTermSearch(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            autoFocus
                                                            style={{
                                                                width: '100%',
                                                                padding: '6px 10px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #d1d5db',
                                                                fontSize: '14px',
                                                                outline: 'none'
                                                            }}
                                                        />
                                                    </div>
                                                    {/* Header for Payment Terms */}
                                                    <div style={{
                                                        display: 'flex',
                                                        padding: '8px 12px',
                                                        backgroundColor: '#f9fafb',
                                                        borderBottom: '1px solid #e5e7eb',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        color: '#6b7280',
                                                        position: 'sticky',
                                                        top: '45px', /* Adjusted for search height */
                                                        zIndex: 10
                                                    }}>
                                                        <div style={{ flex: '0 0 80px' }}>Term</div>
                                                        <div style={{ flex: 1 }}>Description</div>
                                                    </div>
                                                    {stlDigitalPaymentTermsList
                                                        .filter(t => t.code.toLowerCase().includes(stlPaymentTermSearch.toLowerCase()) || t.desc.toLowerCase().includes(stlPaymentTermSearch.toLowerCase()))
                                                        .map(term => (
                                                            <div
                                                                key={term.code}
                                                                className="dropdown-item"
                                                                style={{
                                                                    display: 'flex',
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #f3f4f6',
                                                                    fontSize: '14px',
                                                                    color: '#374151',
                                                                    backgroundColor: stlFields.terms_of_payment === term.code ? '#eff6ff' : 'transparent'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = stlFields.terms_of_payment === term.code ? '#eff6ff' : 'transparent'}
                                                                onClick={() => {
                                                                    handleStlFieldChange({ target: { name: 'terms_of_payment', value: term.code } });
                                                                    setIsStlPaymentTermDropdownOpen(false);
                                                                }}
                                                            >
                                                                <div style={{ flex: '0 0 80px', fontWeight: '500' }}>{term.code}</div>
                                                                <div style={{ flex: 1, color: '#6b7280', whiteSpace: 'pre-wrap' }}>{term.desc}</div>
                                                            </div>
                                                        ))}
                                                </div>
                                                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }} onClick={() => setIsStlPaymentTermDropdownOpen(false)} />
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">
                                        Order Currency <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => {
                                                if (!status.loading) {
                                                    setIsStlCurrencyDropdownOpen(!isStlCurrencyDropdownOpen);
                                                    setStlCurrencySearch('');
                                                }
                                            }}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                minHeight: '42px',
                                                paddingRight: '12px'
                                            }}
                                        >
                                            <span style={{ color: stlFields.order_currency ? '#374151' : '#9ca3af' }}>
                                                {stlFields.order_currency || 'Select Currency'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>
                                        {isStlCurrencyDropdownOpen && (
                                            <>
                                                <div className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    width: '100%',
                                                    zIndex: 100, /* ⬆️ Increased z-index */
                                                    border: '1px solid #d1d5db',
                                                    backgroundColor: '#fff',
                                                    borderRadius: '0.375rem',
                                                    maxHeight: '240px', /* ⬇️ Reduced height */
                                                    overflowY: 'auto',
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                    marginTop: '4px'
                                                }}>
                                                    <div style={{ position: 'sticky', top: 0, backgroundColor: '#fff', padding: '8px', borderBottom: '1px solid #e5e7eb', zIndex: 20 }}>
                                                        <input
                                                            type="text"
                                                            placeholder="Search currency..."
                                                            value={stlCurrencySearch}
                                                            onChange={(e) => setStlCurrencySearch(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            autoFocus
                                                            style={{
                                                                width: '100%',
                                                                padding: '6px 10px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #d1d5db',
                                                                fontSize: '14px',
                                                                outline: 'none'
                                                            }}
                                                        />
                                                    </div>
                                                    {/* Header for Currency */}
                                                    <div style={{
                                                        display: 'flex',
                                                        padding: '8px 12px',
                                                        backgroundColor: '#f9fafb',
                                                        borderBottom: '1px solid #e5e7eb',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        color: '#6b7280',
                                                        position: 'sticky',
                                                        top: '45px',
                                                        zIndex: 10
                                                    }}>
                                                        <div style={{ flex: '0 0 80px' }}>Currency</div>
                                                        <div style={{ flex: 1 }}>Description</div>
                                                    </div>
                                                    {stlDigitalCurrencyList
                                                        .filter(c => c.code.toLowerCase().includes(stlCurrencySearch.toLowerCase()) || c.desc.toLowerCase().includes(stlCurrencySearch.toLowerCase()))
                                                        .map(currency => (
                                                            <div
                                                                key={currency.code}
                                                                className="dropdown-item"
                                                                style={{
                                                                    display: 'flex',
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #f3f4f6',
                                                                    fontSize: '14px',
                                                                    color: '#374151',
                                                                    backgroundColor: stlFields.order_currency === currency.code ? '#eff6ff' : 'transparent'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = stlFields.order_currency === currency.code ? '#eff6ff' : 'transparent'}
                                                                onClick={() => {
                                                                    handleStlFieldChange({ target: { name: 'order_currency', value: currency.code } });
                                                                    setIsStlCurrencyDropdownOpen(false);
                                                                }}
                                                            >
                                                                <div style={{ flex: '0 0 80px', fontWeight: '500' }}>{currency.code}</div>
                                                                <div style={{ flex: 1, color: '#6b7280' }}>{currency.desc}</div>
                                                            </div>
                                                        ))}
                                                </div>
                                                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }} onClick={() => setIsStlCurrencyDropdownOpen(false)} />
                                            </>
                                        )}
                                    </div>
                                </div>

                            </div>



                            {/* Row 5: Payment Method */}
                            <div className="onb-fields-row">
                                <div className="form-group">
                                    <label className="form-label">
                                        Inco Terms <span className="text-red-500">*</span>
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => {
                                                if (!status.loading) {
                                                    setIsStlIncoTermDropdownOpen(!isStlIncoTermDropdownOpen);
                                                    setStlIncoTermSearch('');
                                                }
                                            }}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                minHeight: '42px',
                                                paddingRight: '12px'
                                            }}
                                        >
                                            <span style={{ color: stlFields.incoterms ? '#374151' : '#9ca3af' }}>
                                                {stlFields.incoterms || 'Select Inco Term'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>
                                        {isStlIncoTermDropdownOpen && (
                                            <>
                                                <div className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    width: '100%',
                                                    zIndex: 100,
                                                    border: '1px solid #d1d5db',
                                                    backgroundColor: '#fff',
                                                    borderRadius: '0.375rem',
                                                    maxHeight: '155px',
                                                    overflowY: 'auto',
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                    marginTop: '4px'
                                                }}>
                                                    <div style={{ position: 'sticky', top: 0, backgroundColor: '#fff', padding: '8px', borderBottom: '1px solid #e5e7eb', zIndex: 20 }}>
                                                        <input
                                                            type="text"
                                                            placeholder="Search inco term..."
                                                            value={stlIncoTermSearch}
                                                            onChange={(e) => setStlIncoTermSearch(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            autoFocus
                                                            style={{
                                                                width: '100%',
                                                                padding: '6px 10px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #d1d5db',
                                                                fontSize: '14px',
                                                                outline: 'none'
                                                            }}
                                                        />
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        padding: '8px 12px',
                                                        backgroundColor: '#f9fafb',
                                                        borderBottom: '1px solid #e5e7eb',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        color: '#6b7280',
                                                        position: 'sticky',
                                                        top: '45px',
                                                        zIndex: 10
                                                    }}>
                                                        <div style={{ flex: '0 0 50px' }}>Term</div>
                                                        <div style={{ flex: 1 }}>Description</div>
                                                    </div>
                                                    {stlDigitalIncoTermsList
                                                        .filter(t => t.code.toLowerCase().includes(stlIncoTermSearch.toLowerCase()) || t.desc.toLowerCase().includes(stlIncoTermSearch.toLowerCase()))
                                                        .map(term => (
                                                            <div
                                                                key={term.code}
                                                                className="dropdown-item"
                                                                style={{
                                                                    display: 'flex',
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #f3f4f6',
                                                                    fontSize: '14px',
                                                                    color: '#374151',
                                                                    backgroundColor: stlFields.incoterms === term.code ? '#eff6ff' : 'transparent'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = stlFields.incoterms === term.code ? '#eff6ff' : 'transparent'}
                                                                onClick={() => {
                                                                    handleStlFieldChange({ target: { name: 'incoterms', value: term.code } });
                                                                    setIsStlIncoTermDropdownOpen(false);
                                                                }}
                                                            >
                                                                <div style={{ flex: '0 0 50px', fontWeight: '500' }}>{term.code}</div>
                                                                <div style={{ flex: 1, color: '#6b7280' }}>{term.desc}</div>
                                                            </div>
                                                        ))}
                                                </div>
                                                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }} onClick={() => setIsStlIncoTermDropdownOpen(false)} />
                                            </>
                                        )}
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="form-label">
                                        Payment Method (Optional)
                                    </label>
                                    <div style={{ position: 'relative' }}>
                                        <div
                                            className="form-input form-select"
                                            onClick={() => {
                                                if (!status.loading) {
                                                    setIsStlPaymentMethodDropdownOpen(!isStlPaymentMethodDropdownOpen);
                                                    setStlPaymentMethodSearch('');
                                                }
                                            }}
                                            style={{
                                                cursor: status.loading ? 'not-allowed' : 'pointer',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                backgroundColor: status.loading ? '#f3f4f6' : '#fff',
                                                minHeight: '42px',
                                                paddingRight: '12px'
                                            }}
                                        >
                                            <span style={{ color: stlFields.payment_method ? '#374151' : '#9ca3af' }}>
                                                {stlFields.payment_method || 'Select Payment Method'}
                                            </span>
                                            <FaChevronDown style={{ color: '#6b7280', fontSize: '12px' }} />
                                        </div>
                                        {isStlPaymentMethodDropdownOpen && (
                                            <>
                                                <div className="dropdown-menu" style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    width: '100%',
                                                    zIndex: 100,
                                                    border: '1px solid #d1d5db',
                                                    backgroundColor: '#fff',
                                                    borderRadius: '0.375rem',
                                                    maxHeight: '155px',
                                                    overflowY: 'auto',
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                    marginTop: '4px'
                                                }}>
                                                    <div style={{ position: 'sticky', top: 0, backgroundColor: '#fff', padding: '8px', borderBottom: '1px solid #e5e7eb', zIndex: 20 }}>
                                                        <input
                                                            type="text"
                                                            placeholder="Search payment method..."
                                                            value={stlPaymentMethodSearch}
                                                            onChange={(e) => setStlPaymentMethodSearch(e.target.value)}
                                                            onClick={(e) => e.stopPropagation()}
                                                            autoFocus
                                                            style={{
                                                                width: '100%',
                                                                padding: '6px 10px',
                                                                borderRadius: '4px',
                                                                border: '1px solid #d1d5db',
                                                                fontSize: '14px',
                                                                outline: 'none'
                                                            }}
                                                        />
                                                    </div>
                                                    <div style={{
                                                        display: 'flex',
                                                        padding: '8px 12px',
                                                        backgroundColor: '#f9fafb',
                                                        borderBottom: '1px solid #e5e7eb',
                                                        fontSize: '12px',
                                                        fontWeight: '600',
                                                        color: '#6b7280',
                                                        position: 'sticky',
                                                        top: '45px',
                                                        zIndex: 10
                                                    }}>
                                                        <div style={{ flex: '0 0 50px' }}>Code</div>
                                                        <div style={{ flex: 1 }}>Description</div>
                                                    </div>
                                                    <div
                                                        className="dropdown-item"
                                                        style={{
                                                            display: 'flex',
                                                            padding: '8px 12px',
                                                            cursor: 'pointer',
                                                            borderBottom: '1px solid #f3f4f6',
                                                            color: '#2c2a2aff',
                                                            fontStyle: 'italic',
                                                            backgroundColor: 'transparent'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                                        onClick={() => {
                                                            handleStlFieldChange({ target: { name: 'payment_method', value: '' } });
                                                            setIsStlPaymentMethodDropdownOpen(false);
                                                        }}
                                                    >
                                                        <div style={{ flex: '0 0 50px', fontWeight: '500' }}>None</div>
                                                        <div style={{ flex: 1, color: '#0f0101ff' }}></div>
                                                    </div>
                                                    {stlDigitalPaymentMethodList
                                                        .filter(m => m.code.toLowerCase().includes(stlPaymentMethodSearch.toLowerCase()) || m.desc.toLowerCase().includes(stlPaymentMethodSearch.toLowerCase()))
                                                        .map(method => (
                                                            <div
                                                                key={method.code}
                                                                className="dropdown-item"
                                                                style={{
                                                                    display: 'flex',
                                                                    padding: '8px 12px',
                                                                    cursor: 'pointer',
                                                                    borderBottom: '1px solid #f3f4f6',
                                                                    fontSize: '14px',
                                                                    color: '#374151',
                                                                    backgroundColor: stlFields.payment_method === method.code ? '#eff6ff' : 'transparent'
                                                                }}
                                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = stlFields.payment_method === method.code ? '#eff6ff' : 'transparent'}
                                                                onClick={() => {
                                                                    handleStlFieldChange({ target: { name: 'payment_method', value: method.code } });
                                                                    setIsStlPaymentMethodDropdownOpen(false);
                                                                }}
                                                            >
                                                                <div style={{ flex: '0 0 50px', fontWeight: '500' }}>{method.code}</div>
                                                                <div style={{ flex: 1, color: '#6b7280' }}>{method.desc}</div>
                                                            </div>
                                                        ))}
                                                </div>
                                                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 40 }} onClick={() => setIsStlPaymentMethodDropdownOpen(false)} />
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* 🆕 Row 6: Incoterms Location 1 & 2 (Conditional) */}
                            {stlFields.incoterms && stlFields.incoterms !== 'NA' && (
                                <div className="onb-fields-row">
                                    <div className="form-group">
                                        <label className="form-label">
                                            Incoterms Location 1 <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-input"
                                            name="incoterms_part_2"
                                            value={stlFields.incoterms_part_2}
                                            maxLength={stlFields.incoterms !== 'NA' ? 70 : undefined}
                                            onChange={handleStlFieldChange}
                                            placeholder="Enter Location 1"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {
                        isEditing && (
                            <div className="add-field-section">
                                <button type="button" className="btn-add-field" onClick={handleAddField} disabled={status.loading}>
                                    <PlusIcon className="mr-2" /> Add New Field
                                </button>
                            </div>
                        )
                    }

                    {
                        !isEditing && (
                            <button type="submit" disabled={status.loading} className="btn-initiate">
                                {status.loading ? 'Initiating...' : 'Initiate Onboarding'}
                            </button>
                        )
                    }
                </form >
            </div >
        </div >
    );
};

export default AdminOnboardingInitiate;